import { ToastController } from "@ionic/angular";

export const humanize = (val: number) => {

  if (val < 1024) {
    return + 'B';
  }

  val = val / 1024;
  if (val < 1024) {
    return round(val) + 'KB';
  }

  val = val / 1024;
  if (val < 1024) {
    return round(val) + 'MB';
  }

  val = val / 1024;
  if (val < 1024) {
    return round(val) + 'GB';
  }

  val = val / 1024;
  return round(val) + 'TB';

}

function round(n, p = 2) {
  n = n * (10 ^ p)
  n = Math.round(n);
  n = n / (10 ^ p)
  return n;

}

export const thumbnailify = (base64Image, targetSize, compression = 0.8) => {


  var img = new Image();
  img.src = base64Image;
  //console.log('thumb1',img)
  return new Promise<string>(resolve => {
    img.onload = () => {
      //console.log('thumb2')
      // step 1 - resize to 50%
      var oc = document.createElement('canvas'),
        octx = oc.getContext('2d');
        //console.log('thumb3')
      let ratio = (targetSize / img.width);

      oc.width = img.width * ratio;
      oc.height = img.height * ratio;
      octx.drawImage(img, 0, 0, oc.width, oc.height);

      // step 2
      //octx.drawImage(img, 0, 0, oc.width * ratio, oc.height * ratio);
      /*
              // step 3, resize to final size
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              ctx.drawImage(oc, 0, 0, oc.width * ratio, oc.height * ratio,
                0, 0, oc.width, oc.height);
      */
      let res = oc.toDataURL('image/jpeg', compression);
      resolve(res);

    }

  })

};
/* Croppa un'immagine in base64 rimuovendo la percentuale indicata dai margini.
 * @param {string} base64Str - L'immagine originale in formato base64.
 * @param {number} marginPercent - La percentuale totale da rimuovere dai margini (es. 30).
 * @returns {Promise<string>} - Una Promise che risolve nel nuovo base64 croppato.
 */
export const cropCenterBase64 = (base64Str: string, marginPercent = 30): Promise<string> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = base64Str;

        img.onload = () => {
            // 1. Calcola la percentuale da tagliare per singolo lato (es. 30% totale -> 15% a sinistra, 15% a destra)
            const sideMarginPercent = marginPercent / 2;

            // 2. Calcola le coordinate di offset (X e Y di partenza)
            const sx = img.width * (sideMarginPercent / 100);
            const sy = img.height * (sideMarginPercent / 100);

            // 3. Calcola la larghezza e l'altezza della zona centrale da tenere (es. 100% - 30% = 70%)
            const sWidth = img.width * ((100 - marginPercent) / 100);
            const sHeight = img.height * ((100 - marginPercent) / 100);

            // 4. Configura il canvas con le dimensioni del rettangolo centrale
            const canvas = document.createElement('canvas');
            canvas.width = sWidth;
            canvas.height = sHeight;
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                reject(new Error("Impossibile ottenere il contesto 2D del canvas"));
                return;
            }

            // 5. Disegna la porzione ritagliata sul canvas
            // Parametri: img, sx, sy, sWidth, sHeight (sorgente) -> dx, dy, dWidth, dHeight (destinazione sul canvas)
            ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, sWidth, sHeight);

            // 6. Esporta il risultato in base64 (puoi cambiare il tipo es. 'image/jpeg')
            const croppedBase64:string = canvas.toDataURL('image/png');
            resolve(croppedBase64);
        };

        img.onerror = (err) => {
            reject(err);
        };
    });
}

export const dummy = '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'
export const image_not_avalaible = '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'

export const toastMessage = async (toastcontroller: ToastController, msg: string, duration = 1000) => {

  let toast = await toastcontroller.create({ message: msg, duration: duration })
  toast.present();

}

export const getEnv = function () {
  let env = localStorage.getItem('ENVIRONMENT');

  if (!env) {
    env = localStorage.getItem('ENVIRONMENT');
    /*
    var retVal = confirm("Vuoi usare l'ambiente di TEST?");
    if (retVal) {
      localStorage.setItem('ENVIRONMENT', 'test');
    } else {
      localStorage.setItem('ENVIRONMENT', 'prod');
    }
    env = localStorage.getItem('ENVIRONMENT');
    alert('Hai selezionato: ' + env);
    */
  }

  return env;
}

export const getColor = function () {
  switch (getEnv()) {
    case 'test':
      return "warning"
    default:
      return "primary"
  }
}


export const getDamageTypes = [
    {
      "code": "G",
      "zone": "Esterni",
      "description": "Graffio"
    },
    {
      "code": "A",
      "zone": "Esterni",
      "description": "Ammaccatura"
    },
    {
      "code": "DF",
      "zone": "Esterni",
      "description": "Deformazione"
    },
	{
      "code": "R",
      "zone": "Esterni",
      "description": "Rottura"
    },
    {
      "code": "M",
      "zone": "Esterni",
      "description": "Mancante"
    },
    {
      "code": "B",
      "zone": "Interni",
      "description": "Bruciatura"
    },
    {
      "code": "F",
      "zone": "Interni",
      "description": "Fenditura"
    },
    {
      "code": "M",
      "zone": "Interni",
      "description": "Mancante"
    },
    {
      "code": "R",
      "zone": "Interni",
      "description": "Rottura"
    },
    {
      "code": "C",
      "zone": "Interni",
      "description": "Consumato"
    },
    {
      "code": "T",
      "zone": "Meccanica",
      "description": "Trafilazione"
    },
    {
      "code": "VAD",
      "zone": "Meccanica",
      "description": "Verifica con diagnosi"
    }
  ]


/*

export const getDamageTypes = [
  {
    "code": "G",
    "zone": "Esterni",
    "description": "Graffio"
  },
  {
    "code": "A",
    "zone": "Esterni",
    "description": "Ammaccatura   "
  },
  {
    "code": "F",
    "zone": "Esterni",
    "description": "Fenditura"
  },
  {
    "code": "DF",
    "zone": "Esterni",
    "description": "Deformazione"
  },
  {
    "code": "I",
    "zone": "Esterni",
    "description": "Incidente"
  },
  {
    "code": "P",
    "zone": "Esterni",
    "description": "Puntini sassi"
  },
  {
    "code": "D",
    "zone": "Esterni",
    "description": "Difetto "
  },
  {
    "code": "M",
    "zone": "Esterni",
    "description": "Mancante"
  },
  {
    "code": "R",
    "zone": "Esterni",
    "description": "Rottura"
  },
  {
    "code": "B",
    "zone": "Interni",
    "description": "Bruciatura"
  },
  {
    "code": "F",
    "zone": "Interni",
    "description": "Fenditura"
  },
  {
    "code": "M",
    "zone": "Interni",
    "description": "Mancante"
  },
  {
    "code": "R",
    "zone": "Interni",
    "description": "Rottura"
  },
  {
    "code": "C",
    "zone": "Interni",
    "description": "Consumato"
  },
  {
    "code": "T",
    "zone": "Meccanica",
    "description": "Trafilazione"
  },
  {
    "code": "VAD",
    "zone": "Meccanica",
    "description": "Verifica con diagnosi"
  }
]

*/


export const ZONE_ELEMENTS = [
  {
      "code": "1",
      "description": "Paraurti ANT",
      "vehType": "suv",
      "sostituzione": "674.1866667",
      "lieve": "38.43333333",
      "medio": "65.93333333",
      "grave": "93.93333333",
      "#3828db": "1"
  },
  {
      "code": "2",
      "description": "Cofano",
      "vehType": "suv",
      "sostituzione": "713.0433333",
      "lieve": "63.5",
      "medio": "135.3",
      "grave": "138.5333333",
      "#3828db": "1"
  },
  {
      "code": "3",
      "description": "Parafango ANT SX",
      "vehType": "suv",
      "sostituzione": "454.8533333",
      "lieve": "65.86666667",
      "medio": "140.4333333",
      "grave": "196.9",
      "#ee1313": "1"
  },
  {
      "code": "4",
      "description": "Parafango ANT DX",
      "vehType": "suv",
      "sostituzione": "454.8533333",
      "lieve": "65.86666667",
      "medio": "140.4333333",
      "grave": "196.9",
      "#26f719": "1"
  },
  {
      "code": "5",
      "description": "Tetto",
      "vehType": "suv",
      "sostituzione": "1456.17",
      "lieve": "125.5666667",
      "medio": "297.0333333",
      "grave": "497.1666667",
      "#b1a558": "1"
  },
  {
      "code": "6",
      "description": "Porta ANT SX",
      "vehType": "suv",
      "sostituzione": "955.1933333",
      "lieve": "81.63333333",
      "medio": "184.3666667",
      "grave": "266.0666667",
      "#db6928": "1"
  },
  {
      "code": "7",
      "description": "Porta ANT DX",
      "vehType": "suv",
      "sostituzione": "955.1933333",
      "lieve": "81.63333333",
      "medio": "184.3666667",
      "grave": "266.0666667",
      "#3e6928": "1"
  },
  {
      "code": "8",
      "description": "Porta POST SX",
      "vehType": "suv",
      "sostituzione": "1011.72",
      "lieve": "77.8",
      "medio": "174",
      "grave": "250.8333333",
      "#db6928": "1"
  },
  {
      "code": "9",
      "description": "Porta POST DX",
      "vehType": "suv",
      "sostituzione": "1011.72",
      "lieve": "77.8",
      "medio": "174",
      "grave": "250.8333333",
      "#3e6928": "1"
  },
  {
      "code": "10",
      "description": "Lunotto",
      "vehType": "suv",
      "sostituzione": "482.14",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "11",
      "description": "Parafango POST SX",
      "vehType": "suv",
      "sostituzione": "1045.423333",
      "lieve": "104.5333333",
      "medio": "244.8666667",
      "grave": "414.5666667",
      "#af28db": "1"
  },
  {
      "code": "12",
      "description": "Parafango POST DX",
      "vehType": "suv",
      "sostituzione": "1045.423333",
      "lieve": "104.5333333",
      "medio": "244.8666667",
      "grave": "414.5666667",
      "#87a5f0": "1"
  },
  {
      "code": "1010",
      "description": "Portellone POST",
      "vehType": "suv",
      "sostituzione": "1313.45",
      "lieve": "75.73333333",
      "medio": "168.4333333",
      "grave": "239.4666667",
      "#eaf910": "1"
  },
  {
      "code": "13",
      "description": "Paraurti POST",
      "vehType": "suv",
      "sostituzione": "599.87",
      "lieve": "18.1",
      "medio": "32.9",
      "grave": "50.56666667",
      "#eaf910": "1"
  },
  {
      "code": "14",
      "description": "Parabrezza",
      "vehType": "suv",
      "sostituzione": "562.4826667",
      "lieve": "",
      "medio": "58",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "16",
      "description": "Porta POST laterale DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "31",
      "description": "Cerchione ANT SX in ferro",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "36",
      "description": "Pannelli porte (SX o DX)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "1320",
      "description": "Paraurti centrale posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1L",
      "description": "Paraurti ANT (lato sx)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1L01",
      "description": "Minigonna ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1R",
      "description": "Paraurti ANT (lato dx)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1R01",
      "description": "Minigonna ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "3WA",
      "description": "Arco passaruota ANT SX",
      "vehType": "suv",
      "sostituzione": "105.3233333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "4WA",
      "description": "Arco passaruota ANT DX",
      "vehType": "suv",
      "sostituzione": "105.18",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "78",
      "description": "Coppa ruota",
      "vehType": "suv",
      "sostituzione": "65.05",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "80",
      "description": "Coprimozzo ",
      "vehType": "suv",
      "sostituzione": "20.58666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "84",
      "description": "Portatarga",
      "vehType": "suv",
      "sostituzione": "38.31",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1",
      "#eaf910": "1"
  },
  {
      "code": "100",
      "description": "Proiettore ANT DX",
      "vehType": "suv",
      "sostituzione": "1365.58",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "101",
      "description": "Griglia paraurti ANT",
      "vehType": "suv",
      "sostituzione": "219.72",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "102",
      "description": "Spoiler paraurti ANT",
      "vehType": "suv",
      "sostituzione": "98.705",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "103",
      "description": "Proiettore ANT SX",
      "vehType": "suv",
      "sostituzione": "1365.58",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "104",
      "description": "Targa ANT",
      "vehType": "suv",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "105",
      "description": "Griglia ANT (nel cofano o separata)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "106",
      "description": "Stemma ANT",
      "vehType": "suv",
      "sostituzione": "39.58666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "107",
      "description": "Freccia ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "108",
      "description": "Faro antinebbia SX",
      "vehType": "suv",
      "sostituzione": "257.36",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "109",
      "description": "Modanatura paraurti ANT (DX o SX)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "110",
      "description": "Freccia ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "111",
      "description": "Faro antinebbia DX",
      "vehType": "suv",
      "sostituzione": "254.26",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "118",
      "description": "Coppa ruota",
      "vehType": "suv",
      "sostituzione": "65.05",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "126",
      "description": "Interruttore accensione luci",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "130",
      "description": "Luce diurna ANT DX Posizione",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "138",
      "description": "Spazzola tergicristallo posteriore",
      "vehType": "suv",
      "sostituzione": "66.06",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "140",
      "description": "Luce diurna ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "141",
      "description": "Volante",
      "vehType": "suv",
      "sostituzione": "1873.71",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "301",
      "description": "Indicatore di direzione SX (laterale parafango)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "306",
      "description": "Pneumatico ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "307",
      "description": "Cerchio in acciaio ANT SX",
      "vehType": "suv",
      "sostituzione": "121.14",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "308",
      "description": "Cerchio in lega ANT SX",
      "vehType": "suv",
      "sostituzione": "393.7833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "401",
      "description": "Indicatore di direzione DX (laterale parafango)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "406",
      "description": "Pneumatico ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "407",
      "description": "Cerchio in acciaio ANT DX",
      "vehType": "suv",
      "sostituzione": "121.14",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "408",
      "description": "Cerchio in lega ANT DX",
      "vehType": "suv",
      "sostituzione": "393.7833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "501",
      "description": "Antenna",
      "vehType": "suv",
      "sostituzione": "65.14333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "502",
      "description": "Barre mancorrenti",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "503",
      "description": "Capote COMPLETA",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "504",
      "description": "Tetto apribile (lamierato)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "505",
      "description": "Copertura capote solo tela",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "506",
      "description": "Spoiler portello",
      "vehType": "suv",
      "sostituzione": "570.36",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "510",
      "description": "Rivestimento anteriore esterno",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "511",
      "description": "Tetto retraibile (tettuccio senza meccanismo)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "560",
      "description": "Barra tetto SX Modan",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "570",
      "description": "Barra tetto DX Modan",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "601",
      "description": "Sottoporta SX",
      "vehType": "suv",
      "sostituzione": "605.105",
      "lieve": "50",
      "medio": "85.8",
      "grave": "140.7",
      "#db6928": "1"
  },
  {
      "code": "602",
      "description": "Modanatura porta ANT SX",
      "vehType": "suv",
      "sostituzione": "160.49",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "603",
      "description": "Serie cilindretti serrature",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "604",
      "description": "Maniglia porta esterna ANT SX",
      "vehType": "suv",
      "sostituzione": "111.6166667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "605",
      "description": "Vetro scendente ANT SX",
      "vehType": "suv",
      "sostituzione": "169.92",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "606",
      "description": "Calotta retrovisore SX",
      "vehType": "suv",
      "sostituzione": "93.98333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "607",
      "description": "Retrovisore lato guida",
      "vehType": "suv",
      "sostituzione": "440.21",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "609",
      "description": "Vetro fisso ANT SX",
      "vehType": "suv",
      "sostituzione": "122.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "612",
      "description": "Cristallo retrovisore SX",
      "vehType": "suv",
      "sostituzione": "105.2166667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "701",
      "description": "Sottoporta DX",
      "vehType": "suv",
      "sostituzione": "605.105",
      "lieve": "50",
      "medio": "85.8",
      "grave": "140.7",
      "#3e6928": "1"
  },
  {
      "code": "702",
      "description": "Modanatura porta ANT DX",
      "vehType": "suv",
      "sostituzione": "160.49",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "703",
      "description": "Cilindretto serratura porta ant.",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "704",
      "description": "Maniglia porta esterna ANT DX",
      "vehType": "suv",
      "sostituzione": "111.6166667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "705",
      "description": "Vetro scendente ANT DX",
      "vehType": "suv",
      "sostituzione": "169.92",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "706",
      "description": "Calotta retrovisore DX",
      "vehType": "suv",
      "sostituzione": "93.98333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "707",
      "description": "Retrovisore lato passggero",
      "vehType": "suv",
      "sostituzione": "440.21",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "712",
      "description": "Cristallo retrovisore DX",
      "vehType": "suv",
      "sostituzione": "105.2166667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "713",
      "description": "Vetro fisso ANT DX",
      "vehType": "suv",
      "sostituzione": "122.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "804",
      "description": "Maniglia porta esterna POST SX",
      "vehType": "suv",
      "sostituzione": "106.1333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "805",
      "description": "Vetro scendente porta POST SX",
      "vehType": "suv",
      "sostituzione": "134.04",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "806",
      "description": "Vetro fisso POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "807",
      "description": "Guarnizione porta POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "811",
      "description": "Pannello porta POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "904",
      "description": "Maniglia porta esterna POST DX",
      "vehType": "suv",
      "sostituzione": "106.1333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "905",
      "description": "Vetro scendenteporta POST DX",
      "vehType": "suv",
      "sostituzione": "134.04",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "906",
      "description": "Vetro fisso POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "907",
      "description": "Guarnizione porta POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "908",
      "description": "Modanatura paraurti POST",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1001",
      "description": "Spazzole tergicristallo POST",
      "vehType": "suv",
      "sostituzione": "55.07",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1002",
      "description": "Braccio tergicristallo POST",
      "vehType": "suv",
      "sostituzione": "49.505",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1003",
      "description": "Luce terzo stop",
      "vehType": "suv",
      "sostituzione": "100.9",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1011",
      "description": "Maniglia apertura portello post",
      "vehType": "suv",
      "sostituzione": "285.755",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1013",
      "description": "Meccanismo apertura/chiusura capote",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1014",
      "description": "Terminale di scarico (silenz di scarico)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1101",
      "description": "Tappo carburante lato SX",
      "vehType": "suv",
      "sostituzione": "84.91333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1102",
      "description": "Sportello carburante lato SX",
      "vehType": "suv",
      "sostituzione": "52.65333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1103",
      "description": "Modanatura parafango ANT ",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "1106",
      "description": "Pneumatico POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1107",
      "description": "Cerchio in acciaio POST SX",
      "vehType": "suv",
      "sostituzione": "121.14",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1108",
      "description": "Cerchio in lega POST SX",
      "vehType": "suv",
      "sostituzione": "393.7833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1112",
      "description": "Sostegno/supporto (ruota scorta)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1114",
      "description": "Cerchione POST SX (ferro)",
      "vehType": "suv",
      "sostituzione": "98.23",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1201",
      "description": "Tappo carburante lato DX",
      "vehType": "suv",
      "sostituzione": "84.91333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1202",
      "description": "Sportello carburante lato DX",
      "vehType": "suv",
      "sostituzione": "52.65333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1203",
      "description": "Errato rifornimento",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1204",
      "description": "Modanatura parafango POST",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1206",
      "description": "Pneumatico POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1207",
      "description": "Cerchio in acciaio POST DX",
      "vehType": "suv",
      "sostituzione": "121.14",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1208",
      "description": "Cerchio in lega POST",
      "vehType": "suv",
      "sostituzione": "393.7833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1222",
      "description": "Cerchione POST DX (ferro)",
      "vehType": "suv",
      "sostituzione": "121.14",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1223",
      "description": "Arco passaruota POST DX",
      "vehType": "suv",
      "sostituzione": "131.72",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1225",
      "description": "Sostegno/supporto",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1301",
      "description": "Griglia paraurti POST",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1302",
      "description": "Spoiler paraurti POST",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1303",
      "description": "Luce POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1304",
      "description": "Targa POST",
      "vehType": "suv",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1305",
      "description": "Griglia paraurti ANT inf.",
      "vehType": "suv",
      "sostituzione": "200.91",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1306",
      "description": "Stemma POST",
      "vehType": "suv",
      "sostituzione": "44.24333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1307",
      "description": "Freccia POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1308",
      "description": "Luce retronebbia posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1309",
      "description": "Gancio di traino smontabile J",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1310",
      "description": "Luce POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1311",
      "description": "Fanale POST SX",
      "vehType": "suv",
      "sostituzione": "304.0766667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1312",
      "description": "Fanale POST DX",
      "vehType": "suv",
      "sostituzione": "281.61",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1313",
      "description": "Freccia POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1314",
      "description": "Luce targa singola",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1317",
      "description": "Gancio di traino",
      "vehType": "suv",
      "sostituzione": "364.38",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1322",
      "description": "Serratura portello posteriore",
      "vehType": "suv",
      "sostituzione": "143.0833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1325",
      "description": "Luce di posizione POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1326",
      "description": "Luce di posizione POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1401",
      "description": "Spazzole tergicristallo ANT",
      "vehType": "suv",
      "sostituzione": "60.36333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1402",
      "description": "Braccio tergicristallo ANT",
      "vehType": "suv",
      "sostituzione": "75.36333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1403",
      "description": "Braccio tergicristallo ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1404",
      "description": "Braccio tergicristallo ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1405",
      "description": "Spazzola tergicristallo ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1406",
      "description": "Spazzola tergicristallo ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1407",
      "description": "Spazzole tergicristallo",
      "vehType": "suv",
      "sostituzione": "55.07",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1505",
      "description": "Tappo gancio traino paraurti (ANT e POST)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1508",
      "description": "Fisso parafango ant. SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1509",
      "description": "Fisso parafango ant. DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1510",
      "description": "Luce di posizione ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1511",
      "description": "Luce di posizione ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1512",
      "description": "Monobraccio tergicristallo anteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1700",
      "description": "Chiave (seconda chiave)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1702",
      "description": "Manuale d'uso e manutenzione",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1703",
      "description": "Radio (vedi allestimento)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1704",
      "description": "Accendisigari",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1705",
      "description": "Posacenere",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1706",
      "description": "Leva cambio (pomello)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1708",
      "description": "Retrovisore interno",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1709",
      "description": "Comando regolazione retrovisore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1710",
      "description": "Cruscotto (plancia)",
      "vehType": "suv",
      "sostituzione": "2240.596667",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1713",
      "description": "Poggiatesta sedile singolo",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1720",
      "description": "Cappelliera post.",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1721",
      "description": "Triangolo di emergenza",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1722",
      "description": "Chiave smontaruota",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1723",
      "description": "Crick ruota scorta (martinetto)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1725",
      "description": "Altoparlanti tweeter",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1726",
      "description": "Altoparlante posteriore/sub",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1727",
      "description": "Compressore d'aria",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1728",
      "description": "Maniglia porta ANT interna (SX o DX)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1729",
      "description": "Manovella alzacristalli",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1730",
      "description": "Estintore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1731",
      "description": "Rivestimento vano bagagli LAT",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1732",
      "description": "Ripiano interno copribagagliaio",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1733",
      "description": "Telecomando",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1734",
      "description": "Caricatore CD",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1735",
      "description": "Portabollo/assicurazione",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1736",
      "description": "Moquette",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1737",
      "description": "Tappetini",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1738",
      "description": "Cinture di Sicurezza ",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1739",
      "description": "Rivestimento interno tetto (cielo)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1740",
      "description": "Kit prontosoccorso",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1741",
      "description": "Bullone antifurto",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1742",
      "description": "Plafoniera interna",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1743",
      "description": "Rete fermabagagli",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1745",
      "description": "Cassetto portaoggetti (sportello)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1747",
      "description": "Riparo inferiore CARTER MOTORE",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1748",
      "description": "Airbag passeggero",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1749",
      "description": "Airbag lato guida",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1750",
      "description": "Pulizia interni extra",
      "vehType": "suv",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1751",
      "description": "Poggiabraccia ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1752",
      "description": "Poggiabraccia POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1754",
      "description": "Tunnel centrale completo",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1755",
      "description": "Moquette ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1756",
      "description": "Moquette ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1757",
      "description": "Moquette POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1758",
      "description": "Moquette POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1759",
      "description": "Quadro strumenti",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1760",
      "description": "Pannello porta ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1761",
      "description": "Poggiatesta ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1763",
      "description": "Schienale sedile ANT SX (solo fodera)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1764",
      "description": "Seduta ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1765",
      "description": "Comando alzavetro ANT DX",
      "vehType": "suv",
      "sostituzione": "313.1066667",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1766",
      "description": "Comandoalzavetro ANT SX",
      "vehType": "suv",
      "sostituzione": "313.1066667",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1767",
      "description": "Comandoalzavetro POST DX",
      "vehType": "suv",
      "sostituzione": "398.66",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1768",
      "description": "Comando alzavetro POST SX",
      "vehType": "suv",
      "sostituzione": "398.66",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1770",
      "description": "Pannello porta ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1771",
      "description": "Poggiatesta ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1772",
      "description": "Schienale sedile ANT DX (solo fodera)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1773",
      "description": "Seduta ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1774",
      "description": "Sedile passeggero COMPLETO",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1776",
      "description": "Poggiatesta POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1777",
      "description": "Schienale sedile POST DX (solo fodera)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1778",
      "description": "Seduta sedile POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1779",
      "description": "Schienale sedile POST SX (solo fodera)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1780",
      "description": "Pannello interno portello posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1781",
      "description": "Seduta sedile POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1783",
      "description": "Cintura di sicurezza POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1784",
      "description": "Altoparlante ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1785",
      "description": "Altoparlante POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1786",
      "description": "Altoparlante ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1787",
      "description": "Altoparlante POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1788",
      "description": "Aletta parasole ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1790",
      "description": "Pannello porta POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1791",
      "description": "Impianto di navigazione (solo display)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1792",
      "description": "Poggiabraccia POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1793",
      "description": "Poggiabraccia ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1794",
      "description": "Airbag laterale SX tendina",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1795",
      "description": "Airbag laterale DX tendinta",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1796",
      "description": "Poggiatesta POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1797",
      "description": "Cintura di sicurezza POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1804",
      "description": "Coprimozzo ",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1811",
      "description": "Disco GPS",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1812",
      "description": "Kit attrezzi",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1813",
      "description": "Giubbino di emergenza",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4001",
      "description": "Cerchione ANT DX in ferro",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "6061",
      "description": "Freccia retrovisore SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "6071",
      "description": "Freccia retrovisore DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "7301",
      "description": "Ruota di scorta in ferro ruotino",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "7302",
      "description": "Ruota di scorta in lega",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11D",
      "description": "Modanatura montante porta post. SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "11WA",
      "description": "Passaruota/Parasassi Int. ANT, parte ANT/POST",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "12D",
      "description": "Modanatura montante porta post. DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "13L1",
      "description": "Luce antinebbia POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "13R1",
      "description": "Luce antinebbia POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "17B1",
      "description": "Sedile POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B2",
      "description": "Seduta POST centrale",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B3",
      "description": "Sedile POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F1",
      "description": "Sedile ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F2",
      "description": "Sedile ANT centrale",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F3",
      "description": "Sedile ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T7",
      "description": "Comandi climatizzatore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U5",
      "description": "Portachiavi",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U6",
      "description": "Specchio di cortesia",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U7",
      "description": "Cintura di sicurezza ANT DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U9",
      "description": "Cintura di sicurezza ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W1",
      "description": "Rivestimento interno (battivaligia)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W2",
      "description": "Aletta parasole ANT SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W4",
      "description": "SD GPS",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W5",
      "description": "Caricabatteria GPS",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W6",
      "description": "Staffa supporto GPS",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W7",
      "description": "Contenitore GPS",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W8",
      "description": "Custodia GPS",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17X1",
      "description": "Cavo di ricarica veicolo elettrico",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "6B",
      "description": "Modanatura montante porta ant. SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "7B",
      "description": "Modanatura montante porta ant. DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "8C",
      "description": "Modanatura montante centrale SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "9C",
      "description": "Modanatura montante centrale DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "3A",
      "description": "Parete laterale esterna SX (truck)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4A",
      "description": "Parete laterale esterna DX (truck)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "81",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "82",
      "description": "Pannello superiore portello posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "83",
      "description": "Pannello inferiore portello posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "122",
      "description": "Pannello superiore porta carico POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "123",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "132",
      "description": "Pannello MONTANTE superiore POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "133",
      "description": "Pannello inferiore POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "134",
      "description": "Pannello MONTANTE superiore POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "135",
      "description": "Pannello inferiore POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "220",
      "description": "Luce di ingombro dx",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "302",
      "description": "Modanatura laterale SX (rifinitura lat.plastica)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "507",
      "description": "Parete divisoria vano di carico",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "709",
      "description": "Specchio retrovisore supplementare",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "711",
      "description": "Pedana di carico DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "803",
      "description": "Cilindretto serratura portello post",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "808",
      "description": "Fascia paracolpi  porta carico  POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "815",
      "description": "Protezione inferiore laterale SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "817",
      "description": "Barra di protezione lato guida",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "903",
      "description": "Serratura porta POST",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "915",
      "description": "Protezione inferiore laterale DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "917",
      "description": "Barra di protezione lato passeggero",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1004",
      "description": "Pedana posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1105",
      "description": "Vetro laterale POST SX truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1110",
      "description": "Pannello laterale interno SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1111",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1113",
      "description": "Pannello interno posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1205",
      "description": "Vetro laterale DX truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1209",
      "description": "Vetro laterale POST DX truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1210",
      "description": "Pannello laterale interno DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1220",
      "description": "Pannello superiore porta carico POST SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1221",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1315",
      "description": "Fascia paracolpi porta carico POST DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1316",
      "description": "Soglia acceso vano carico(Truck)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1501",
      "description": "Pannello interno DX superiore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1502",
      "description": "Pannello interno DX inferiore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1503",
      "description": "Pannello interno SX superiore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1504",
      "description": "Pannello interno SX inferiore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1520",
      "description": "Luce di ingombro sx",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1746",
      "description": "Piano di carico posteiore interno",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1753",
      "description": "Divisorio vano carico",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1799",
      "description": "Unità di controllo interna",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1809",
      "description": "Adesivo Europcar",
      "vehType": "suv",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1810",
      "description": "Deflettore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11CO",
      "description": "Angolare truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "12CO",
      "description": "Angolare truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13L",
      "description": "Angolo SX Paraurti POST solo truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13R",
      "description": "Angolo DX Paraurti POST solo truck",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T1",
      "description": "Terza fila di sedili SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T2",
      "description": "Terza fila di sedili centrale",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T3",
      "description": "Terza fila di sedili DX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U1",
      "description": "Rivestimento verticale coibentato",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U2",
      "description": "Pavimento coibentato",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U3",
      "description": "Rivestimento tetto coibentato",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U4",
      "description": "Comando controllo frigo",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U8",
      "description": "Panca sedile",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W3",
      "description": "Pianale di carico (copertura)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "139",
      "description": "Unità di controllo pedana posteriore",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "402",
      "description": "Modanatura laterale DX (rifinitura lat plastica)",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "611",
      "description": "Pedana di carico SX",
      "vehType": "suv",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1",
      "description": "Paraurti ANT",
      "vehType": "sw",
      "sostituzione": "605.3666667",
      "lieve": "37",
      "medio": "61.23333333",
      "grave": "88.03333333",
      "#3828db": "1"
  },
  {
      "code": "2",
      "description": "Cofano",
      "vehType": "sw",
      "sostituzione": "653.8633333",
      "lieve": "64.53333333",
      "medio": "133.8666667",
      "grave": "231.9333333",
      "#3828db": "1"
  },
  {
      "code": "3",
      "description": "Parafango ANT SX",
      "vehType": "sw",
      "sostituzione": "411.8233333",
      "lieve": "60.2",
      "medio": "124.7333333",
      "grave": "210.2666667",
      "#ee1313": "1"
  },
  {
      "code": "4",
      "description": "Parafango ANT DX",
      "vehType": "sw",
      "sostituzione": "411.8233333",
      "lieve": "60.2",
      "medio": "124.7333333",
      "grave": "210.2666667",
      "#26f719": "1"
  },
  {
      "code": "5",
      "description": "Tetto",
      "vehType": "sw",
      "sostituzione": "1290.653333",
      "lieve": "120.7333333",
      "medio": "282.4333333",
      "grave": "474.8666667",
      "#b1a558": "1"
  },
  {
      "code": "6",
      "description": "Porta ANT SX",
      "vehType": "sw",
      "sostituzione": "849.3066667",
      "lieve": "76.93333333",
      "medio": "174.9666667",
      "grave": "299.1",
      "#db6928": "1"
  },
  {
      "code": "7",
      "description": "Porta ANT DX",
      "vehType": "sw",
      "sostituzione": "849.3066667",
      "lieve": "76.93333333",
      "medio": "174.9666667",
      "grave": "299.1",
      "#3e6928": "1"
  },
  {
      "code": "8",
      "description": "Porta POST SX",
      "vehType": "sw",
      "sostituzione": "797.8966667",
      "lieve": "76.36666667",
      "medio": "172.8",
      "grave": "295.3333333",
      "#db6928": "1"
  },
  {
      "code": "9",
      "description": "Porta POST DX",
      "vehType": "sw",
      "sostituzione": "797.8966667",
      "lieve": "76.36666667",
      "medio": "172.8",
      "grave": "295.3333333",
      "#3e6928": "1"
  },
  {
      "code": "10",
      "description": "Lunotto",
      "vehType": "sw",
      "sostituzione": "524.17",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "11",
      "description": "Parafango POST SX",
      "vehType": "sw",
      "sostituzione": "1254.163333",
      "lieve": "103.6",
      "medio": "238.2333333",
      "grave": "402.8",
      "#af28db": "1"
  },
  {
      "code": "12",
      "description": "Parafango POST DX",
      "vehType": "sw",
      "sostituzione": "1254.163333",
      "lieve": "103.6",
      "medio": "238.2333333",
      "grave": "402.8",
      "#87a5f0": "1"
  },
  {
      "code": "1010",
      "description": "Portellone POST",
      "vehType": "sw",
      "sostituzione": "954.2033333",
      "lieve": "73.26666667",
      "medio": "168.1333333",
      "grave": "295.7333333",
      "#eaf910": "1"
  },
  {
      "code": "13",
      "description": "Paraurti POST",
      "vehType": "sw",
      "sostituzione": "651.52",
      "lieve": "37.63333333",
      "medio": "64.33333333",
      "grave": "93.2",
      "#eaf910": "1"
  },
  {
      "code": "14",
      "description": "Parabrezza",
      "vehType": "sw",
      "sostituzione": "576.8326667",
      "lieve": "",
      "medio": "58",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "16",
      "description": "Porta POST laterale DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "31",
      "description": "Cerchione ANT SX in ferro",
      "vehType": "sw",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "36",
      "description": "Pannelli porte (SX o DX)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "1320",
      "description": "Paraurti centrale posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1L",
      "description": "Paraurti ANT (lato sx)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1L01",
      "description": "Minigonna ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1R",
      "description": "Paraurti ANT (lato dx)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1R01",
      "description": "Minigonna ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "3WA",
      "description": "Arco passaruota ANT SX",
      "vehType": "sw",
      "sostituzione": "91.55666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "4WA",
      "description": "Arco passaruota ANT DX",
      "vehType": "sw",
      "sostituzione": "91.55666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "78",
      "description": "Coppa ruota",
      "vehType": "sw",
      "sostituzione": "34.38",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "80",
      "description": "Coprimozzo ",
      "vehType": "sw",
      "sostituzione": "14.47",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "84",
      "description": "Portatarga",
      "vehType": "sw",
      "sostituzione": "7.19",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1",
      "#eaf910": "1"
  },
  {
      "code": "100",
      "description": "Proiettore ANT DX",
      "vehType": "sw",
      "sostituzione": "1501.8",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "101",
      "description": "Griglia paraurti ANT",
      "vehType": "sw",
      "sostituzione": "145.6",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "102",
      "description": "Spoiler paraurti ANT",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "103",
      "description": "Proiettore ANT SX",
      "vehType": "sw",
      "sostituzione": "1501.8",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "104",
      "description": "Targa ANT",
      "vehType": "sw",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "105",
      "description": "Griglia ANT (nel cofano o separata)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "106",
      "description": "Stemma ANT",
      "vehType": "sw",
      "sostituzione": "38.015",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "107",
      "description": "Freccia ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "108",
      "description": "Faro antinebbia SX",
      "vehType": "sw",
      "sostituzione": "225.9166667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "109",
      "description": "Modanatura paraurti ANT (DX o SX)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "110",
      "description": "Freccia ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "111",
      "description": "Faro antinebbia DX",
      "vehType": "sw",
      "sostituzione": "225.9166667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "118",
      "description": "Coppa ruota",
      "vehType": "sw",
      "sostituzione": "34.38",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "126",
      "description": "Interruttore accensione luci",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "130",
      "description": "Luce diurna ANT DX Posizione",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "138",
      "description": "Spazzola tergicristallo posteriore",
      "vehType": "sw",
      "sostituzione": "35.54",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "140",
      "description": "Luce diurna ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "141",
      "description": "Volante",
      "vehType": "sw",
      "sostituzione": "601.03",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "301",
      "description": "Indicatore di direzione SX (laterale parafango)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "306",
      "description": "Pneumatico ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "307",
      "description": "Cerchio in acciaio ANT SX",
      "vehType": "sw",
      "sostituzione": "96.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "308",
      "description": "Cerchio in lega ANT SX",
      "vehType": "sw",
      "sostituzione": "369.2033333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "401",
      "description": "Indicatore di direzione DX (laterale parafango)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "406",
      "description": "Pneumatico ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "407",
      "description": "Cerchio in acciaio ANT DX",
      "vehType": "sw",
      "sostituzione": "213.3733333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "408",
      "description": "Cerchio in lega ANT DX",
      "vehType": "sw",
      "sostituzione": "329.895",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "501",
      "description": "Antenna",
      "vehType": "sw",
      "sostituzione": "113.825",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "502",
      "description": "Barre mancorrenti",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "503",
      "description": "Capote COMPLETA",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "504",
      "description": "Tetto apribile (lamierato)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "505",
      "description": "Copertura capote solo tela",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "506",
      "description": "Spoiler portello",
      "vehType": "sw",
      "sostituzione": "319.1366667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "510",
      "description": "Rivestimento anteriore esterno",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "511",
      "description": "Tetto retraibile (tettuccio senza meccanismo)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "560",
      "description": "Barra tetto SX Modan",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "570",
      "description": "Barra tetto DX Modan",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "601",
      "description": "Sottoporta SX",
      "vehType": "sw",
      "sostituzione": "504.775",
      "lieve": "48.8",
      "medio": "85.8",
      "grave": "140.7",
      "#db6928": "1"
  },
  {
      "code": "602",
      "description": "Modanatura porta ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "603",
      "description": "Serie cilindretti serrature",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "604",
      "description": "Maniglia porta esterna ANT SX",
      "vehType": "sw",
      "sostituzione": "104.2833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "605",
      "description": "Vetro scendente ANT SX",
      "vehType": "sw",
      "sostituzione": "195.8033333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "606",
      "description": "Calotta retrovisore SX",
      "vehType": "sw",
      "sostituzione": "143.01",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "607",
      "description": "Retrovisore lato guida",
      "vehType": "sw",
      "sostituzione": "424.1633333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "609",
      "description": "Vetro fisso ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "612",
      "description": "Cristallo retrovisore SX",
      "vehType": "sw",
      "sostituzione": "409.31",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "701",
      "description": "Sottoporta DX",
      "vehType": "sw",
      "sostituzione": "504.775",
      "lieve": "48.8",
      "medio": "85.8",
      "grave": "140.7",
      "#3e6928": "1"
  },
  {
      "code": "702",
      "description": "Modanatura porta ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "703",
      "description": "Cilindretto serratura porta ant.",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "704",
      "description": "Maniglia porta esterna ANT DX",
      "vehType": "sw",
      "sostituzione": "104.2833333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "705",
      "description": "Vetro scendente ANT DX",
      "vehType": "sw",
      "sostituzione": "195.8033333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "706",
      "description": "Calotta retrovisore DX",
      "vehType": "sw",
      "sostituzione": "143.01",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "707",
      "description": "Retrovisore lato passggero",
      "vehType": "sw",
      "sostituzione": "424.1633333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "712",
      "description": "Cristallo retrovisore DX",
      "vehType": "sw",
      "sostituzione": "409.31",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "713",
      "description": "Vetro fisso ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "804",
      "description": "Maniglia porta esterna POST SX",
      "vehType": "sw",
      "sostituzione": "102.89",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "805",
      "description": "Vetro scendente porta POST SX",
      "vehType": "sw",
      "sostituzione": "179.61",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "806",
      "description": "Vetro fisso POST SX",
      "vehType": "sw",
      "sostituzione": "231.935",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "807",
      "description": "Guarnizione porta POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "811",
      "description": "Pannello porta POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "904",
      "description": "Maniglia porta esterna POST DX",
      "vehType": "sw",
      "sostituzione": "102.89",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "905",
      "description": "Vetro scendenteporta POST DX",
      "vehType": "sw",
      "sostituzione": "179.61",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "906",
      "description": "Vetro fisso POST DX",
      "vehType": "sw",
      "sostituzione": "231.935",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "907",
      "description": "Guarnizione porta POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "908",
      "description": "Modanatura paraurti POST",
      "vehType": "sw",
      "sostituzione": "57.23",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1001",
      "description": "Spazzole tergicristallo POST",
      "vehType": "sw",
      "sostituzione": "31.665",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1002",
      "description": "Braccio tergicristallo POST",
      "vehType": "sw",
      "sostituzione": "44.85",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1003",
      "description": "Luce terzo stop",
      "vehType": "sw",
      "sostituzione": "120.99",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1011",
      "description": "Maniglia apertura portello post",
      "vehType": "sw",
      "sostituzione": "54.62333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1013",
      "description": "Meccanismo apertura/chiusura capote",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1014",
      "description": "Terminale di scarico (silenz di scarico)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1101",
      "description": "Tappo carburante lato SX",
      "vehType": "sw",
      "sostituzione": "47.635",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1102",
      "description": "Sportello carburante lato SX",
      "vehType": "sw",
      "sostituzione": "47.24333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1103",
      "description": "Modanatura parafango ANT ",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "1106",
      "description": "Pneumatico POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1107",
      "description": "Cerchio in acciaio POST SX",
      "vehType": "sw",
      "sostituzione": "96.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1108",
      "description": "Cerchio in lega POST SX",
      "vehType": "sw",
      "sostituzione": "477.46",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1112",
      "description": "Sostegno/supporto (ruota scorta)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1114",
      "description": "Cerchione POST SX (ferro)",
      "vehType": "sw",
      "sostituzione": "96.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1201",
      "description": "Tappo carburante lato DX",
      "vehType": "sw",
      "sostituzione": "47.635",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1202",
      "description": "Sportello carburante lato DX",
      "vehType": "sw",
      "sostituzione": "47.24333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1203",
      "description": "Errato rifornimento",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1204",
      "description": "Modanatura parafango POST",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1206",
      "description": "Pneumatico POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1207",
      "description": "Cerchio in acciaio POST DX",
      "vehType": "sw",
      "sostituzione": "96.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1208",
      "description": "Cerchio in lega POST",
      "vehType": "sw",
      "sostituzione": "477.46",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1222",
      "description": "Cerchione POST DX (ferro)",
      "vehType": "sw",
      "sostituzione": "96.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1223",
      "description": "Arco passaruota POST DX",
      "vehType": "sw",
      "sostituzione": "67.215",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1225",
      "description": "Sostegno/supporto",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1301",
      "description": "Griglia paraurti POST",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1302",
      "description": "Spoiler paraurti POST",
      "vehType": "sw",
      "sostituzione": "127.595",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1303",
      "description": "Luce POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1304",
      "description": "Targa POST",
      "vehType": "sw",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1305",
      "description": "Griglia paraurti ANT inf.",
      "vehType": "sw",
      "sostituzione": "1097.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1306",
      "description": "Stemma POST",
      "vehType": "sw",
      "sostituzione": "42.215",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1307",
      "description": "Freccia POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1308",
      "description": "Luce retronebbia posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1309",
      "description": "Gancio di traino smontabile J",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1310",
      "description": "Luce POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1311",
      "description": "Fanale POST SX",
      "vehType": "sw",
      "sostituzione": "369.33",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1312",
      "description": "Fanale POST DX",
      "vehType": "sw",
      "sostituzione": "433.49",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1313",
      "description": "Freccia POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1314",
      "description": "Luce targa singola",
      "vehType": "sw",
      "sostituzione": "40.94",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1317",
      "description": "Gancio di traino",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1322",
      "description": "Serratura portello posteriore",
      "vehType": "sw",
      "sostituzione": "150.7133333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1325",
      "description": "Luce di posizione POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1326",
      "description": "Luce di posizione POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1401",
      "description": "Spazzole tergicristallo ANT",
      "vehType": "sw",
      "sostituzione": "70.95",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1402",
      "description": "Braccio tergicristallo ANT",
      "vehType": "sw",
      "sostituzione": "63.685",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1403",
      "description": "Braccio tergicristallo ANT DX",
      "vehType": "sw",
      "sostituzione": "51.105",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1404",
      "description": "Braccio tergicristallo ANT SX",
      "vehType": "sw",
      "sostituzione": "51.105",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1405",
      "description": "Spazzola tergicristallo ANT DX",
      "vehType": "sw",
      "sostituzione": "34.45",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1406",
      "description": "Spazzola tergicristallo ANT SX",
      "vehType": "sw",
      "sostituzione": "34.45",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1407",
      "description": "Spazzole tergicristallo",
      "vehType": "sw",
      "sostituzione": "61.7",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1505",
      "description": "Tappo gancio traino paraurti (ANT e POST)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1508",
      "description": "Fisso parafango ant. SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1509",
      "description": "Fisso parafango ant. DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1510",
      "description": "Luce di posizione ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1511",
      "description": "Luce di posizione ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1512",
      "description": "Monobraccio tergicristallo anteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1700",
      "description": "Chiave (seconda chiave)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1702",
      "description": "Manuale d'uso e manutenzione",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1703",
      "description": "Radio (vedi allestimento)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1704",
      "description": "Accendisigari",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1705",
      "description": "Posacenere",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1706",
      "description": "Leva cambio (pomello)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1708",
      "description": "Retrovisore interno",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1709",
      "description": "Comando regolazione retrovisore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1710",
      "description": "Cruscotto (plancia)",
      "vehType": "sw",
      "sostituzione": "978.125",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1713",
      "description": "Poggiatesta sedile singolo",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1720",
      "description": "Cappelliera post.",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1721",
      "description": "Triangolo di emergenza",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1722",
      "description": "Chiave smontaruota",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1723",
      "description": "Crick ruota scorta (martinetto)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1725",
      "description": "Altoparlanti tweeter",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1726",
      "description": "Altoparlante posteriore/sub",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1727",
      "description": "Compressore d'aria",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1728",
      "description": "Maniglia porta ANT interna (SX o DX)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1729",
      "description": "Manovella alzacristalli",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1730",
      "description": "Estintore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1731",
      "description": "Rivestimento vano bagagli LAT",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1732",
      "description": "Ripiano interno copribagagliaio",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1733",
      "description": "Telecomando",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1734",
      "description": "Caricatore CD",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1735",
      "description": "Portabollo/assicurazione",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1736",
      "description": "Moquette",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1737",
      "description": "Tappetini",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1738",
      "description": "Cinture di Sicurezza ",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1739",
      "description": "Rivestimento interno tetto (cielo)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1740",
      "description": "Kit prontosoccorso",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1741",
      "description": "Bullone antifurto",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1742",
      "description": "Plafoniera interna",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1743",
      "description": "Rete fermabagagli",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1745",
      "description": "Cassetto portaoggetti (sportello)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1747",
      "description": "Riparo inferiore CARTER MOTORE",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1748",
      "description": "Airbag passeggero",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1749",
      "description": "Airbag lato guida",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1750",
      "description": "Pulizia interni extra",
      "vehType": "sw",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1751",
      "description": "Poggiabraccia ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1752",
      "description": "Poggiabraccia POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1754",
      "description": "Tunnel centrale completo",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1755",
      "description": "Moquette ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1756",
      "description": "Moquette ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1757",
      "description": "Moquette POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1758",
      "description": "Moquette POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1759",
      "description": "Quadro strumenti",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1760",
      "description": "Pannello porta ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1761",
      "description": "Poggiatesta ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1763",
      "description": "Schienale sedile ANT SX (solo fodera)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1764",
      "description": "Seduta ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1765",
      "description": "Comando alzavetro ANT DX",
      "vehType": "sw",
      "sostituzione": "165.8233333",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1766",
      "description": "Comandoalzavetro ANT SX",
      "vehType": "sw",
      "sostituzione": "165.8233333",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1767",
      "description": "Comandoalzavetro POST DX",
      "vehType": "sw",
      "sostituzione": "151.94",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1768",
      "description": "Comando alzavetro POST SX",
      "vehType": "sw",
      "sostituzione": "151.94",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1770",
      "description": "Pannello porta ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1771",
      "description": "Poggiatesta ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1772",
      "description": "Schienale sedile ANT DX (solo fodera)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1773",
      "description": "Seduta ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1774",
      "description": "Sedile passeggero COMPLETO",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1776",
      "description": "Poggiatesta POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1777",
      "description": "Schienale sedile POST DX (solo fodera)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1778",
      "description": "Seduta sedile POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1779",
      "description": "Schienale sedile POST SX (solo fodera)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1780",
      "description": "Pannello interno portello posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1781",
      "description": "Seduta sedile POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1783",
      "description": "Cintura di sicurezza POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1784",
      "description": "Altoparlante ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1785",
      "description": "Altoparlante POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1786",
      "description": "Altoparlante ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1787",
      "description": "Altoparlante POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1788",
      "description": "Aletta parasole ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1790",
      "description": "Pannello porta POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1791",
      "description": "Impianto di navigazione (solo display)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1792",
      "description": "Poggiabraccia POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1793",
      "description": "Poggiabraccia ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1794",
      "description": "Airbag laterale SX tendina",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1795",
      "description": "Airbag laterale DX tendinta",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1796",
      "description": "Poggiatesta POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1797",
      "description": "Cintura di sicurezza POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1804",
      "description": "Coprimozzo ",
      "vehType": "sw",
      "sostituzione": "10.8",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1811",
      "description": "Disco GPS",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1812",
      "description": "Kit attrezzi",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1813",
      "description": "Giubbino di emergenza",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4001",
      "description": "Cerchione ANT DX in ferro",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "6061",
      "description": "Freccia retrovisore SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "6071",
      "description": "Freccia retrovisore DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "7301",
      "description": "Ruota di scorta in ferro ruotino",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "7302",
      "description": "Ruota di scorta in lega",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11D",
      "description": "Modanatura montante porta post. SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "11WA",
      "description": "Passaruota/Parasassi Int. ANT, parte ANT/POST",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "12D",
      "description": "Modanatura montante porta post. DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "13L1",
      "description": "Luce antinebbia POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "13R1",
      "description": "Luce antinebbia POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "17B1",
      "description": "Sedile POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B2",
      "description": "Seduta POST centrale",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B3",
      "description": "Sedile POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F1",
      "description": "Sedile ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F2",
      "description": "Sedile ANT centrale",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F3",
      "description": "Sedile ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T7",
      "description": "Comandi climatizzatore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U5",
      "description": "Portachiavi",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U6",
      "description": "Specchio di cortesia",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U7",
      "description": "Cintura di sicurezza ANT DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U9",
      "description": "Cintura di sicurezza ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W1",
      "description": "Rivestimento interno (battivaligia)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W2",
      "description": "Aletta parasole ANT SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W4",
      "description": "SD GPS",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W5",
      "description": "Caricabatteria GPS",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W6",
      "description": "Staffa supporto GPS",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W7",
      "description": "Contenitore GPS",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W8",
      "description": "Custodia GPS",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17X1",
      "description": "Cavo di ricarica veicolo elettrico",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "6B",
      "description": "Modanatura montante porta ant. SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "7B",
      "description": "Modanatura montante porta ant. DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "8C",
      "description": "Modanatura montante centrale SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "9C",
      "description": "Modanatura montante centrale DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "3A",
      "description": "Parete laterale esterna SX (truck)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4A",
      "description": "Parete laterale esterna DX (truck)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "81",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "82",
      "description": "Pannello superiore portello posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "83",
      "description": "Pannello inferiore portello posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "122",
      "description": "Pannello superiore porta carico POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "123",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "132",
      "description": "Pannello MONTANTE superiore POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "133",
      "description": "Pannello inferiore POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "134",
      "description": "Pannello MONTANTE superiore POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "135",
      "description": "Pannello inferiore POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "220",
      "description": "Luce di ingombro dx",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "302",
      "description": "Modanatura laterale SX (rifinitura lat.plastica)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "507",
      "description": "Parete divisoria vano di carico",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "709",
      "description": "Specchio retrovisore supplementare",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "711",
      "description": "Pedana di carico DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "803",
      "description": "Cilindretto serratura portello post",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "808",
      "description": "Fascia paracolpi  porta carico  POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "815",
      "description": "Protezione inferiore laterale SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "817",
      "description": "Barra di protezione lato guida",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "903",
      "description": "Serratura porta POST",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "915",
      "description": "Protezione inferiore laterale DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "917",
      "description": "Barra di protezione lato passeggero",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1004",
      "description": "Pedana posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1105",
      "description": "Vetro laterale POST SX truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1110",
      "description": "Pannello laterale interno SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1111",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1113",
      "description": "Pannello interno posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1205",
      "description": "Vetro laterale DX truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1209",
      "description": "Vetro laterale POST DX truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1210",
      "description": "Pannello laterale interno DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1220",
      "description": "Pannello superiore porta carico POST SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1221",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1315",
      "description": "Fascia paracolpi porta carico POST DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1316",
      "description": "Soglia acceso vano carico(Truck)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1501",
      "description": "Pannello interno DX superiore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1502",
      "description": "Pannello interno DX inferiore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1503",
      "description": "Pannello interno SX superiore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1504",
      "description": "Pannello interno SX inferiore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1520",
      "description": "Luce di ingombro sx",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1746",
      "description": "Piano di carico posteiore interno",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1753",
      "description": "Divisorio vano carico",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1799",
      "description": "Unità di controllo interna",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1809",
      "description": "Adesivo Europcar",
      "vehType": "sw",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1810",
      "description": "Deflettore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11CO",
      "description": "Angolare truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "12CO",
      "description": "Angolare truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13L",
      "description": "Angolo SX Paraurti POST solo truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13R",
      "description": "Angolo DX Paraurti POST solo truck",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T1",
      "description": "Terza fila di sedili SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T2",
      "description": "Terza fila di sedili centrale",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T3",
      "description": "Terza fila di sedili DX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U1",
      "description": "Rivestimento verticale coibentato",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U2",
      "description": "Pavimento coibentato",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U3",
      "description": "Rivestimento tetto coibentato",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U4",
      "description": "Comando controllo frigo",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U8",
      "description": "Panca sedile",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W3",
      "description": "Pianale di carico (copertura)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "139",
      "description": "Unità di controllo pedana posteriore",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "402",
      "description": "Modanatura laterale DX (rifinitura lat plastica)",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "611",
      "description": "Pedana di carico SX",
      "vehType": "sw",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1",
      "description": "Paraurti ANT",
      "vehType": "berlina",
      "sostituzione": "632.7266667",
      "lieve": "35.8",
      "medio": "58.2",
      "grave": "81.73333333",
      "#3828db": "1"
  },
  {
      "code": "2",
      "description": "Cofano",
      "vehType": "berlina",
      "sostituzione": "686.8933333",
      "lieve": "65.73333333",
      "medio": "134.3333333",
      "grave": "189.0333333",
      "#3828db": "1"
  },
  {
      "code": "3",
      "description": "Parafango ANT SX",
      "vehType": "berlina",
      "sostituzione": "407.78",
      "lieve": "60.76666667",
      "medio": "125.4666667",
      "grave": "172.3",
      "#ee1313": "1"
  },
  {
      "code": "4",
      "description": "Parafango ANT DX",
      "vehType": "berlina",
      "sostituzione": "407.78",
      "lieve": "60.76666667",
      "medio": "125.4666667",
      "grave": "172.3",
      "#26f719": "1"
  },
  {
      "code": "5",
      "description": "Tetto",
      "vehType": "berlina",
      "sostituzione": "1699.296667",
      "lieve": "135.5",
      "medio": "323.7333333",
      "grave": "542.3",
      "#b1a558": "1"
  },
  {
      "code": "6",
      "description": "Porta ANT SX",
      "vehType": "berlina",
      "sostituzione": "873.82",
      "lieve": "76.7",
      "medio": "160.0333333",
      "grave": "292.2",
      "#db6928": "1"
  },
  {
      "code": "7",
      "description": "Porta ANT DX",
      "vehType": "berlina",
      "sostituzione": "873.82",
      "lieve": "76.7",
      "medio": "160.0333333",
      "grave": "292.2",
      "#3e6928": "1"
  },
  {
      "code": "8",
      "description": "Porta POST SX",
      "vehType": "berlina",
      "sostituzione": "861.2166667",
      "lieve": "73.66666667",
      "medio": "166.3666667",
      "grave": "286.2",
      "#db6928": "1"
  },
  {
      "code": "9",
      "description": "Porta POST DX",
      "vehType": "berlina",
      "sostituzione": "861.2166667",
      "lieve": "73.66666667",
      "medio": "166.3666667",
      "grave": "286.2",
      "#3e6928": "1"
  },
  {
      "code": "10",
      "description": "Lunotto",
      "vehType": "berlina",
      "sostituzione": "527.52",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "11",
      "description": "Parafango POST SX",
      "vehType": "berlina",
      "sostituzione": "1414.44",
      "lieve": "104.4",
      "medio": "239.8333333",
      "grave": "405.4333333",
      "#af28db": "1"
  },
  {
      "code": "12",
      "description": "Parafango POST DX",
      "vehType": "berlina",
      "sostituzione": "1414.44",
      "lieve": "104.4",
      "medio": "239.8333333",
      "grave": "405.4333333",
      "#87a5f0": "1"
  },
  {
      "code": "1010",
      "description": "Portellone POST",
      "vehType": "berlina",
      "sostituzione": "944.9366667",
      "lieve": "72.3",
      "medio": "164.6666667",
      "grave": "281.7",
      "#eaf910": "1"
  },
  {
      "code": "13",
      "description": "Paraurti POST",
      "vehType": "berlina",
      "sostituzione": "550.3066667",
      "lieve": "38.36666667",
      "medio": "56.13333333",
      "grave": "78.23333333",
      "#eaf910": "1"
  },
  {
      "code": "14",
      "description": "Parabrezza",
      "vehType": "berlina",
      "sostituzione": "526.743",
      "lieve": "",
      "medio": "58",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "16",
      "description": "Porta POST laterale DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "31",
      "description": "Cerchione ANT SX in ferro",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "36",
      "description": "Pannelli porte (SX o DX)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "1320",
      "description": "Paraurti centrale posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1L",
      "description": "Paraurti ANT (lato sx)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1L01",
      "description": "Minigonna ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1R",
      "description": "Paraurti ANT (lato dx)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1R01",
      "description": "Minigonna ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "3WA",
      "description": "Arco passaruota ANT SX",
      "vehType": "berlina",
      "sostituzione": "68.9",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "4WA",
      "description": "Arco passaruota ANT DX",
      "vehType": "berlina",
      "sostituzione": "68.9",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "78",
      "description": "Coppa ruota",
      "vehType": "berlina",
      "sostituzione": "41.30666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "80",
      "description": "Coprimozzo ",
      "vehType": "berlina",
      "sostituzione": "23.29",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "84",
      "description": "Portatarga",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1",
      "#eaf910": "1"
  },
  {
      "code": "100",
      "description": "Proiettore ANT DX",
      "vehType": "berlina",
      "sostituzione": "1259.705",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "101",
      "description": "Griglia paraurti ANT",
      "vehType": "berlina",
      "sostituzione": "358.0233333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "102",
      "description": "Spoiler paraurti ANT",
      "vehType": "berlina",
      "sostituzione": "124.155",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "103",
      "description": "Proiettore ANT SX",
      "vehType": "berlina",
      "sostituzione": "1297.136667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "104",
      "description": "Targa ANT",
      "vehType": "berlina",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "105",
      "description": "Griglia ANT (nel cofano o separata)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "106",
      "description": "Stemma ANT",
      "vehType": "berlina",
      "sostituzione": "44.17",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "107",
      "description": "Freccia ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "108",
      "description": "Faro antinebbia SX",
      "vehType": "berlina",
      "sostituzione": "122.225",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "109",
      "description": "Modanatura paraurti ANT (DX o SX)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "110",
      "description": "Freccia ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "111",
      "description": "Faro antinebbia DX",
      "vehType": "berlina",
      "sostituzione": "122.225",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "118",
      "description": "Coppa ruota",
      "vehType": "berlina",
      "sostituzione": "41.30666667",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "126",
      "description": "Interruttore accensione luci",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "130",
      "description": "Luce diurna ANT DX Posizione",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "138",
      "description": "Spazzola tergicristallo posteriore",
      "vehType": "berlina",
      "sostituzione": "26.77333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "140",
      "description": "Luce diurna ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "141",
      "description": "Volante",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "301",
      "description": "Indicatore di direzione SX (laterale parafango)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "306",
      "description": "Pneumatico ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "307",
      "description": "Cerchio in acciaio ANT SX",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "308",
      "description": "Cerchio in lega ANT SX",
      "vehType": "berlina",
      "sostituzione": "591.98",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "401",
      "description": "Indicatore di direzione DX (laterale parafango)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "406",
      "description": "Pneumatico ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "407",
      "description": "Cerchio in acciaio ANT DX",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "408",
      "description": "Cerchio in lega ANT DX",
      "vehType": "berlina",
      "sostituzione": "764.755",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "501",
      "description": "Antenna",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "502",
      "description": "Barre mancorrenti",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "503",
      "description": "Capote COMPLETA",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "504",
      "description": "Tetto apribile (lamierato)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "505",
      "description": "Copertura capote solo tela",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "506",
      "description": "Spoiler portello",
      "vehType": "berlina",
      "sostituzione": "476.91",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "510",
      "description": "Rivestimento anteriore esterno",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "511",
      "description": "Tetto retraibile (tettuccio senza meccanismo)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "560",
      "description": "Barra tetto SX Modan",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "570",
      "description": "Barra tetto DX Modan",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "601",
      "description": "Sottoporta SX",
      "vehType": "berlina",
      "sostituzione": "572.1733333",
      "lieve": "48.8",
      "medio": "85.8",
      "grave": "140.7",
      "#db6928": "1"
  },
  {
      "code": "602",
      "description": "Modanatura porta ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "603",
      "description": "Serie cilindretti serrature",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "604",
      "description": "Maniglia porta esterna ANT SX",
      "vehType": "berlina",
      "sostituzione": "148.2966667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "605",
      "description": "Vetro scendente ANT SX",
      "vehType": "berlina",
      "sostituzione": "109.0866667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "606",
      "description": "Calotta retrovisore SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "607",
      "description": "Retrovisore lato guida",
      "vehType": "berlina",
      "sostituzione": "293.82",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "609",
      "description": "Vetro fisso ANT SX",
      "vehType": "berlina",
      "sostituzione": "111.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "612",
      "description": "Cristallo retrovisore SX",
      "vehType": "berlina",
      "sostituzione": "413.88",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "701",
      "description": "Sottoporta DX",
      "vehType": "berlina",
      "sostituzione": "572.1733333",
      "lieve": "48.8",
      "medio": "85.8",
      "grave": "140.7",
      "#3e6928": "1"
  },
  {
      "code": "702",
      "description": "Modanatura porta ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "703",
      "description": "Cilindretto serratura porta ant.",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "704",
      "description": "Maniglia porta esterna ANT DX",
      "vehType": "berlina",
      "sostituzione": "148.3766667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "705",
      "description": "Vetro scendente ANT DX",
      "vehType": "berlina",
      "sostituzione": "109.0866667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "706",
      "description": "Calotta retrovisore DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "707",
      "description": "Retrovisore lato passggero",
      "vehType": "berlina",
      "sostituzione": "293.82",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "712",
      "description": "Cristallo retrovisore DX",
      "vehType": "berlina",
      "sostituzione": "413.88",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "713",
      "description": "Vetro fisso ANT DX",
      "vehType": "berlina",
      "sostituzione": "111.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "804",
      "description": "Maniglia porta esterna POST SX",
      "vehType": "berlina",
      "sostituzione": "113.39",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "805",
      "description": "Vetro scendente porta POST SX",
      "vehType": "berlina",
      "sostituzione": "153.4066667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "806",
      "description": "Vetro fisso POST SX",
      "vehType": "berlina",
      "sostituzione": "164.75",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "807",
      "description": "Guarnizione porta POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "811",
      "description": "Pannello porta POST SX",
      "vehType": "berlina",
      "sostituzione": "926.18",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "904",
      "description": "Maniglia porta esterna POST DX",
      "vehType": "berlina",
      "sostituzione": "113.39",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "905",
      "description": "Vetro scendenteporta POST DX",
      "vehType": "berlina",
      "sostituzione": "153.4066667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "906",
      "description": "Vetro fisso POST DX",
      "vehType": "berlina",
      "sostituzione": "164.75",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "907",
      "description": "Guarnizione porta POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "908",
      "description": "Modanatura paraurti POST",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1001",
      "description": "Spazzole tergicristallo POST",
      "vehType": "berlina",
      "sostituzione": "21.135",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1002",
      "description": "Braccio tergicristallo POST",
      "vehType": "berlina",
      "sostituzione": "37.08",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1003",
      "description": "Luce terzo stop",
      "vehType": "berlina",
      "sostituzione": "89.11",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1011",
      "description": "Maniglia apertura portello post",
      "vehType": "berlina",
      "sostituzione": "282.12",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1013",
      "description": "Meccanismo apertura/chiusura capote",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1014",
      "description": "Terminale di scarico (silenz di scarico)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1101",
      "description": "Tappo carburante lato SX",
      "vehType": "berlina",
      "sostituzione": "71.71",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1102",
      "description": "Sportello carburante lato SX",
      "vehType": "berlina",
      "sostituzione": "56.07666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1103",
      "description": "Modanatura parafango ANT ",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "1106",
      "description": "Pneumatico POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1107",
      "description": "Cerchio in acciaio POST SX",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1108",
      "description": "Cerchio in lega POST SX",
      "vehType": "berlina",
      "sostituzione": "591.98",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1112",
      "description": "Sostegno/supporto (ruota scorta)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1114",
      "description": "Cerchione POST SX (ferro)",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1201",
      "description": "Tappo carburante lato DX",
      "vehType": "berlina",
      "sostituzione": "71.71",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1202",
      "description": "Sportello carburante lato DX",
      "vehType": "berlina",
      "sostituzione": "46.035",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1203",
      "description": "Errato rifornimento",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1204",
      "description": "Modanatura parafango POST",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1206",
      "description": "Pneumatico POST DX",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1207",
      "description": "Cerchio in acciaio POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1208",
      "description": "Cerchio in lega POST",
      "vehType": "berlina",
      "sostituzione": "591.98",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1222",
      "description": "Cerchione POST DX (ferro)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1223",
      "description": "Arco passaruota POST DX",
      "vehType": "berlina",
      "sostituzione": "68.245",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1225",
      "description": "Sostegno/supporto",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1301",
      "description": "Griglia paraurti POST",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1302",
      "description": "Spoiler paraurti POST",
      "vehType": "berlina",
      "sostituzione": "133.965",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1303",
      "description": "Luce POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1304",
      "description": "Targa POST",
      "vehType": "berlina",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1305",
      "description": "Griglia paraurti ANT inf.",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1306",
      "description": "Stemma POST",
      "vehType": "berlina",
      "sostituzione": "34.5",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1307",
      "description": "Freccia POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1308",
      "description": "Luce retronebbia posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1309",
      "description": "Gancio di traino smontabile J",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1310",
      "description": "Luce POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1311",
      "description": "Fanale POST SX",
      "vehType": "berlina",
      "sostituzione": "251.7233333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1312",
      "description": "Fanale POST DX",
      "vehType": "berlina",
      "sostituzione": "251.7233333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1313",
      "description": "Freccia POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1314",
      "description": "Luce targa singola",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1317",
      "description": "Gancio di traino",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1322",
      "description": "Serratura portello posteriore",
      "vehType": "berlina",
      "sostituzione": "81.005",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1325",
      "description": "Luce di posizione POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1326",
      "description": "Luce di posizione POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1401",
      "description": "Spazzole tergicristallo ANT",
      "vehType": "berlina",
      "sostituzione": "53.91666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1402",
      "description": "Braccio tergicristallo ANT",
      "vehType": "berlina",
      "sostituzione": "43.725",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1403",
      "description": "Braccio tergicristallo ANT DX",
      "vehType": "berlina",
      "sostituzione": "55.21333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1404",
      "description": "Braccio tergicristallo ANT SX",
      "vehType": "berlina",
      "sostituzione": "55.21333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1405",
      "description": "Spazzola tergicristallo ANT DX",
      "vehType": "berlina",
      "sostituzione": "35.975",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1406",
      "description": "Spazzola tergicristallo ANT SX",
      "vehType": "berlina",
      "sostituzione": "35.975",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1407",
      "description": "Spazzole tergicristallo",
      "vehType": "berlina",
      "sostituzione": "52.925",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1505",
      "description": "Tappo gancio traino paraurti (ANT e POST)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1508",
      "description": "Fisso parafango ant. SX",
      "vehType": "berlina",
      "sostituzione": "111.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1509",
      "description": "Fisso parafango ant. DX",
      "vehType": "berlina",
      "sostituzione": "111.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1510",
      "description": "Luce di posizione ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1511",
      "description": "Luce di posizione ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1512",
      "description": "Monobraccio tergicristallo anteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1700",
      "description": "Chiave (seconda chiave)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1702",
      "description": "Manuale d'uso e manutenzione",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1703",
      "description": "Radio (vedi allestimento)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1704",
      "description": "Accendisigari",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1705",
      "description": "Posacenere",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1706",
      "description": "Leva cambio (pomello)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1708",
      "description": "Retrovisore interno",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1709",
      "description": "Comando regolazione retrovisore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1710",
      "description": "Cruscotto (plancia)",
      "vehType": "berlina",
      "sostituzione": "1097.3",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1713",
      "description": "Poggiatesta sedile singolo",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1720",
      "description": "Cappelliera post.",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1721",
      "description": "Triangolo di emergenza",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1722",
      "description": "Chiave smontaruota",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1723",
      "description": "Crick ruota scorta (martinetto)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1725",
      "description": "Altoparlanti tweeter",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1726",
      "description": "Altoparlante posteriore/sub",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1727",
      "description": "Compressore d'aria",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1728",
      "description": "Maniglia porta ANT interna (SX o DX)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1729",
      "description": "Manovella alzacristalli",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1730",
      "description": "Estintore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1731",
      "description": "Rivestimento vano bagagli LAT",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1732",
      "description": "Ripiano interno copribagagliaio",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1733",
      "description": "Telecomando",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1734",
      "description": "Caricatore CD",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1735",
      "description": "Portabollo/assicurazione",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1736",
      "description": "Moquette",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1737",
      "description": "Tappetini",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1738",
      "description": "Cinture di Sicurezza ",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1739",
      "description": "Rivestimento interno tetto (cielo)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1740",
      "description": "Kit prontosoccorso",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1741",
      "description": "Bullone antifurto",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1742",
      "description": "Plafoniera interna",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1743",
      "description": "Rete fermabagagli",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1745",
      "description": "Cassetto portaoggetti (sportello)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1747",
      "description": "Riparo inferiore CARTER MOTORE",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1748",
      "description": "Airbag passeggero",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1749",
      "description": "Airbag lato guida",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1750",
      "description": "Pulizia interni extra",
      "vehType": "berlina",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1751",
      "description": "Poggiabraccia ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1752",
      "description": "Poggiabraccia POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1754",
      "description": "Tunnel centrale completo",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1755",
      "description": "Moquette ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1756",
      "description": "Moquette ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1757",
      "description": "Moquette POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1758",
      "description": "Moquette POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1759",
      "description": "Quadro strumenti",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1760",
      "description": "Pannello porta ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1761",
      "description": "Poggiatesta ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1763",
      "description": "Schienale sedile ANT SX (solo fodera)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1764",
      "description": "Seduta ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1765",
      "description": "Comando alzavetro ANT DX",
      "vehType": "berlina",
      "sostituzione": "101.73",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1766",
      "description": "Comandoalzavetro ANT SX",
      "vehType": "berlina",
      "sostituzione": "101.73",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1767",
      "description": "Comandoalzavetro POST DX",
      "vehType": "berlina",
      "sostituzione": "130.87",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1768",
      "description": "Comando alzavetro POST SX",
      "vehType": "berlina",
      "sostituzione": "130.87",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1770",
      "description": "Pannello porta ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1771",
      "description": "Poggiatesta ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1772",
      "description": "Schienale sedile ANT DX (solo fodera)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1773",
      "description": "Seduta ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1774",
      "description": "Sedile passeggero COMPLETO",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1776",
      "description": "Poggiatesta POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1777",
      "description": "Schienale sedile POST DX (solo fodera)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1778",
      "description": "Seduta sedile POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1779",
      "description": "Schienale sedile POST SX (solo fodera)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1780",
      "description": "Pannello interno portello posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1781",
      "description": "Seduta sedile POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1783",
      "description": "Cintura di sicurezza POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1784",
      "description": "Altoparlante ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1785",
      "description": "Altoparlante POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1786",
      "description": "Altoparlante ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1787",
      "description": "Altoparlante POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1788",
      "description": "Aletta parasole ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1790",
      "description": "Pannello porta POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1791",
      "description": "Impianto di navigazione (solo display)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1792",
      "description": "Poggiabraccia POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1793",
      "description": "Poggiabraccia ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1794",
      "description": "Airbag laterale SX tendina",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1795",
      "description": "Airbag laterale DX tendinta",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1796",
      "description": "Poggiatesta POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1797",
      "description": "Cintura di sicurezza POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1804",
      "description": "Coprimozzo ",
      "vehType": "berlina",
      "sostituzione": "33.56",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1811",
      "description": "Disco GPS",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1812",
      "description": "Kit attrezzi",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1813",
      "description": "Giubbino di emergenza",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4001",
      "description": "Cerchione ANT DX in ferro",
      "vehType": "berlina",
      "sostituzione": "90.68",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "6061",
      "description": "Freccia retrovisore SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "6071",
      "description": "Freccia retrovisore DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "7301",
      "description": "Ruota di scorta in ferro ruotino",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "7302",
      "description": "Ruota di scorta in lega",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11D",
      "description": "Modanatura montante porta post. SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "11WA",
      "description": "Passaruota/Parasassi Int. ANT, parte ANT/POST",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "12D",
      "description": "Modanatura montante porta post. DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "13L1",
      "description": "Luce antinebbia POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "13R1",
      "description": "Luce antinebbia POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "17B1",
      "description": "Sedile POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B2",
      "description": "Seduta POST centrale",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B3",
      "description": "Sedile POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F1",
      "description": "Sedile ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F2",
      "description": "Sedile ANT centrale",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F3",
      "description": "Sedile ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T7",
      "description": "Comandi climatizzatore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U5",
      "description": "Portachiavi",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U6",
      "description": "Specchio di cortesia",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U7",
      "description": "Cintura di sicurezza ANT DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U9",
      "description": "Cintura di sicurezza ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W1",
      "description": "Rivestimento interno (battivaligia)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W2",
      "description": "Aletta parasole ANT SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W4",
      "description": "SD GPS",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W5",
      "description": "Caricabatteria GPS",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W6",
      "description": "Staffa supporto GPS",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W7",
      "description": "Contenitore GPS",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W8",
      "description": "Custodia GPS",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17X1",
      "description": "Cavo di ricarica veicolo elettrico",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "6B",
      "description": "Modanatura montante porta ant. SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "7B",
      "description": "Modanatura montante porta ant. DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "8C",
      "description": "Modanatura montante centrale SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "9C",
      "description": "Modanatura montante centrale DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "3A",
      "description": "Parete laterale esterna SX (truck)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4A",
      "description": "Parete laterale esterna DX (truck)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "81",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "82",
      "description": "Pannello superiore portello posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "83",
      "description": "Pannello inferiore portello posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "122",
      "description": "Pannello superiore porta carico POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "123",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "132",
      "description": "Pannello MONTANTE superiore POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "133",
      "description": "Pannello inferiore POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "134",
      "description": "Pannello MONTANTE superiore POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "135",
      "description": "Pannello inferiore POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "220",
      "description": "Luce di ingombro dx",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "302",
      "description": "Modanatura laterale SX (rifinitura lat.plastica)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "507",
      "description": "Parete divisoria vano di carico",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "709",
      "description": "Specchio retrovisore supplementare",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "711",
      "description": "Pedana di carico DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "803",
      "description": "Cilindretto serratura portello post",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "808",
      "description": "Fascia paracolpi  porta carico  POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "815",
      "description": "Protezione inferiore laterale SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "817",
      "description": "Barra di protezione lato guida",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "903",
      "description": "Serratura porta POST",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "915",
      "description": "Protezione inferiore laterale DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "917",
      "description": "Barra di protezione lato passeggero",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1004",
      "description": "Pedana posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1105",
      "description": "Vetro laterale POST SX truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1110",
      "description": "Pannello laterale interno SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1111",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1113",
      "description": "Pannello interno posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1205",
      "description": "Vetro laterale DX truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1209",
      "description": "Vetro laterale POST DX truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1210",
      "description": "Pannello laterale interno DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1220",
      "description": "Pannello superiore porta carico POST SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1221",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1315",
      "description": "Fascia paracolpi porta carico POST DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1316",
      "description": "Soglia acceso vano carico(Truck)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1501",
      "description": "Pannello interno DX superiore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1502",
      "description": "Pannello interno DX inferiore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1503",
      "description": "Pannello interno SX superiore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1504",
      "description": "Pannello interno SX inferiore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1520",
      "description": "Luce di ingombro sx",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1746",
      "description": "Piano di carico posteiore interno",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1753",
      "description": "Divisorio vano carico",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1799",
      "description": "Unità di controllo interna",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1809",
      "description": "Adesivo Europcar",
      "vehType": "berlina",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1810",
      "description": "Deflettore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11CO",
      "description": "Angolare truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "12CO",
      "description": "Angolare truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13L",
      "description": "Angolo SX Paraurti POST solo truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13R",
      "description": "Angolo DX Paraurti POST solo truck",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T1",
      "description": "Terza fila di sedili SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T2",
      "description": "Terza fila di sedili centrale",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T3",
      "description": "Terza fila di sedili DX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U1",
      "description": "Rivestimento verticale coibentato",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U2",
      "description": "Pavimento coibentato",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U3",
      "description": "Rivestimento tetto coibentato",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U4",
      "description": "Comando controllo frigo",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U8",
      "description": "Panca sedile",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W3",
      "description": "Pianale di carico (copertura)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "139",
      "description": "Unità di controllo pedana posteriore",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "402",
      "description": "Modanatura laterale DX (rifinitura lat plastica)",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "611",
      "description": "Pedana di carico SX",
      "vehType": "berlina",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1",
      "description": "Paraurti ANT",
      "vehType": "util",
      "sostituzione": "439.55",
      "lieve": "37.4",
      "medio": "62.4",
      "grave": "92.55",
      "#3828db": "1"
  },
  {
      "code": "2",
      "description": "Cofano",
      "vehType": "util",
      "sostituzione": "661.8166667",
      "lieve": "44.03333333",
      "medio": "95.86666667",
      "grave": "153.3",
      "#3828db": "1"
  },
  {
      "code": "3",
      "description": "Parafango ANT SX",
      "vehType": "util",
      "sostituzione": "319.8366667",
      "lieve": "45.13333333",
      "medio": "91.93333333",
      "grave": "151.8666667",
      "#ee1313": "1"
  },
  {
      "code": "4",
      "description": "Parafango ANT DX",
      "vehType": "util",
      "sostituzione": "319.8366667",
      "lieve": "45.13333333",
      "medio": "91.93333333",
      "grave": "151.8666667",
      "#26f719": "1"
  },
  {
      "code": "5",
      "description": "Tetto",
      "vehType": "util",
      "sostituzione": "1407.79",
      "lieve": "103.3666667",
      "medio": "260.3666667",
      "grave": "433.4333333",
      "#b1a558": "1"
  },
  {
      "code": "6",
      "description": "Porta ANT SX",
      "vehType": "util",
      "sostituzione": "722.89",
      "lieve": "60.83333333",
      "medio": "139.8666667",
      "grave": "239.2",
      "#db6928": "1"
  },
  {
      "code": "7",
      "description": "Porta ANT DX",
      "vehType": "util",
      "sostituzione": "722.89",
      "lieve": "60.83333333",
      "medio": "139.8666667",
      "grave": "239.2",
      "#3e6928": "1"
  },
  {
      "code": "8",
      "description": "Porta POST SX",
      "vehType": "util",
      "sostituzione": "799.515",
      "lieve": "70.8",
      "medio": "160.2",
      "grave": "275.5",
      "#db6928": "1"
  },
  {
      "code": "9",
      "description": "Porta POST DX",
      "vehType": "util",
      "sostituzione": "799.515",
      "lieve": "70.8",
      "medio": "160.2",
      "grave": "275.5",
      "#3e6928": "1"
  },
  {
      "code": "10",
      "description": "Lunotto",
      "vehType": "util",
      "sostituzione": "438.49",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "11",
      "description": "Parafango POST SX",
      "vehType": "util",
      "sostituzione": "987.07",
      "lieve": "86.36666667",
      "medio": "209.5333333",
      "grave": "359.4333333",
      "#af28db": "1"
  },
  {
      "code": "12",
      "description": "Parafango POST DX",
      "vehType": "util",
      "sostituzione": "987.07",
      "lieve": "86.36666667",
      "medio": "209.5333333",
      "grave": "359.4333333",
      "#87a5f0": "1"
  },
  {
      "code": "1010",
      "description": "Portellone POST",
      "vehType": "util",
      "sostituzione": "720.3533333",
      "lieve": "49.03333333",
      "medio": "110.4666667",
      "grave": "190.2",
      "#eaf910": "1"
  },
  {
      "code": "13",
      "description": "Paraurti POST",
      "vehType": "util",
      "sostituzione": "447.725",
      "lieve": "43.4",
      "medio": "66.35",
      "grave": "88",
      "#eaf910": "1"
  },
  {
      "code": "14",
      "description": "Parabrezza",
      "vehType": "util",
      "sostituzione": "383.964",
      "lieve": "",
      "medio": "59.33333333",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "16",
      "description": "Porta POST laterale DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "31",
      "description": "Cerchione ANT SX in ferro",
      "vehType": "util",
      "sostituzione": "81.54",
      "lieve": "",
      "medio": "62",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "36",
      "description": "Pannelli porte (SX o DX)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "1320",
      "description": "Paraurti centrale posteriore",
      "vehType": "util",
      "sostituzione": "93.01",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1L",
      "description": "Paraurti ANT (lato sx)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1L01",
      "description": "Minigonna ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1R",
      "description": "Paraurti ANT (lato dx)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1R01",
      "description": "Minigonna ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "3WA",
      "description": "Arco passaruota ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "4WA",
      "description": "Arco passaruota ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "78",
      "description": "Coppa ruota",
      "vehType": "util",
      "sostituzione": "42.71333333",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "80",
      "description": "Coprimozzo ",
      "vehType": "util",
      "sostituzione": "9.91",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1",
      "#002529": "1",
      "#00254e": "1",
      "#004e4e": "1"
  },
  {
      "code": "84",
      "description": "Portatarga",
      "vehType": "util",
      "sostituzione": "39.3",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1",
      "#eaf910": "1"
  },
  {
      "code": "100",
      "description": "Proiettore ANT DX",
      "vehType": "util",
      "sostituzione": "520.3666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "101",
      "description": "Griglia paraurti ANT",
      "vehType": "util",
      "sostituzione": "144.295",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "102",
      "description": "Spoiler paraurti ANT",
      "vehType": "util",
      "sostituzione": "69.175",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "103",
      "description": "Proiettore ANT SX",
      "vehType": "util",
      "sostituzione": "520.3666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "104",
      "description": "Targa ANT",
      "vehType": "util",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "105",
      "description": "Griglia ANT (nel cofano o separata)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "106",
      "description": "Stemma ANT",
      "vehType": "util",
      "sostituzione": "48.56",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "107",
      "description": "Freccia ANT SX",
      "vehType": "util",
      "sostituzione": "36.95",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "108",
      "description": "Faro antinebbia SX",
      "vehType": "util",
      "sostituzione": "92.28666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "109",
      "description": "Modanatura paraurti ANT (DX o SX)",
      "vehType": "util",
      "sostituzione": "431.5",
      "lieve": "24.4",
      "medio": "65",
      "grave": "100.4",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "110",
      "description": "Freccia ANT DX",
      "vehType": "util",
      "sostituzione": "36.95",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "111",
      "description": "Faro antinebbia DX",
      "vehType": "util",
      "sostituzione": "92.28666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "118",
      "description": "Coppa ruota",
      "vehType": "util",
      "sostituzione": "42.34",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "126",
      "description": "Interruttore accensione luci",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "130",
      "description": "Luce diurna ANT DX Posizione",
      "vehType": "util",
      "sostituzione": "77.22666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "138",
      "description": "Spazzola tergicristallo posteriore",
      "vehType": "util",
      "sostituzione": "53.75",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "140",
      "description": "Luce diurna ANT SX",
      "vehType": "util",
      "sostituzione": "77.22666667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "141",
      "description": "Volante",
      "vehType": "util",
      "sostituzione": "285.34",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "301",
      "description": "Indicatore di direzione SX (laterale parafango)",
      "vehType": "util",
      "sostituzione": "36.95",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "306",
      "description": "Pneumatico ANT SX",
      "vehType": "util",
      "sostituzione": "110.5",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "307",
      "description": "Cerchio in acciaio ANT SX",
      "vehType": "util",
      "sostituzione": "104.6966667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "308",
      "description": "Cerchio in lega ANT SX",
      "vehType": "util",
      "sostituzione": "334.24",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "401",
      "description": "Indicatore di direzione DX (laterale parafango)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "406",
      "description": "Pneumatico ANT DX",
      "vehType": "util",
      "sostituzione": "110.5",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "407",
      "description": "Cerchio in acciaio ANT DX",
      "vehType": "util",
      "sostituzione": "104.6966667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "408",
      "description": "Cerchio in lega ANT DX",
      "vehType": "util",
      "sostituzione": "334.24",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#002529": "1"
  },
  {
      "code": "501",
      "description": "Antenna",
      "vehType": "util",
      "sostituzione": "53.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "502",
      "description": "Barre mancorrenti",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "503",
      "description": "Capote COMPLETA",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "504",
      "description": "Tetto apribile (lamierato)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "505",
      "description": "Copertura capote solo tela",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "506",
      "description": "Spoiler portello",
      "vehType": "util",
      "sostituzione": "110.86",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "510",
      "description": "Rivestimento anteriore esterno",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "511",
      "description": "Tetto retraibile (tettuccio senza meccanismo)",
      "vehType": "util",
      "sostituzione": "988",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "560",
      "description": "Barra tetto SX Modan",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "570",
      "description": "Barra tetto DX Modan",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#b1a558": "1"
  },
  {
      "code": "601",
      "description": "Sottoporta SX",
      "vehType": "util",
      "sostituzione": "145.94",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "602",
      "description": "Modanatura porta ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "603",
      "description": "Serie cilindretti serrature",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1",
      "#3e6928": "1"
  },
  {
      "code": "604",
      "description": "Maniglia porta esterna ANT SX",
      "vehType": "util",
      "sostituzione": "173.38",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "605",
      "description": "Vetro scendente ANT SX",
      "vehType": "util",
      "sostituzione": "144.79",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "606",
      "description": "Calotta retrovisore SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "607",
      "description": "Retrovisore lato guida",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "609",
      "description": "Vetro fisso ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "612",
      "description": "Cristallo retrovisore SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "701",
      "description": "Sottoporta DX",
      "vehType": "util",
      "sostituzione": "145.94",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "702",
      "description": "Modanatura porta ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "703",
      "description": "Cilindretto serratura porta ant.",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "704",
      "description": "Maniglia porta esterna ANT DX",
      "vehType": "util",
      "sostituzione": "173.38",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "705",
      "description": "Vetro scendente ANT DX",
      "vehType": "util",
      "sostituzione": "144.79",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "706",
      "description": "Calotta retrovisore DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "707",
      "description": "Retrovisore lato passggero",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "712",
      "description": "Cristallo retrovisore DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "713",
      "description": "Vetro fisso ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "804",
      "description": "Maniglia porta esterna POST SX",
      "vehType": "util",
      "sostituzione": "94.18",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "805",
      "description": "Vetro scendente porta POST SX",
      "vehType": "util",
      "sostituzione": "147.135",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "806",
      "description": "Vetro fisso POST SX",
      "vehType": "util",
      "sostituzione": "180.98",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "807",
      "description": "Guarnizione porta POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "811",
      "description": "Pannello porta POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "904",
      "description": "Maniglia porta esterna POST DX",
      "vehType": "util",
      "sostituzione": "94.18",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "905",
      "description": "Vetro scendenteporta POST DX",
      "vehType": "util",
      "sostituzione": "154.885",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "906",
      "description": "Vetro fisso POST DX",
      "vehType": "util",
      "sostituzione": "180.98",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "907",
      "description": "Guarnizione porta POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "908",
      "description": "Modanatura paraurti POST",
      "vehType": "util",
      "sostituzione": "265.665",
      "lieve": "24.4",
      "medio": "65",
      "grave": "100.4",
      "#eaf910": "1"
  },
  {
      "code": "1001",
      "description": "Spazzole tergicristallo POST",
      "vehType": "util",
      "sostituzione": "23.66",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1002",
      "description": "Braccio tergicristallo POST",
      "vehType": "util",
      "sostituzione": "34.9",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1003",
      "description": "Luce terzo stop",
      "vehType": "util",
      "sostituzione": "77.51",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1011",
      "description": "Maniglia apertura portello post",
      "vehType": "util",
      "sostituzione": "136.75",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1013",
      "description": "Meccanismo apertura/chiusura capote",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1014",
      "description": "Terminale di scarico (silenz di scarico)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1101",
      "description": "Tappo carburante lato SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1102",
      "description": "Sportello carburante lato SX",
      "vehType": "util",
      "sostituzione": "55.66",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "1103",
      "description": "Modanatura parafango ANT ",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "1106",
      "description": "Pneumatico POST SX",
      "vehType": "util",
      "sostituzione": "110.5",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1107",
      "description": "Cerchio in acciaio POST SX",
      "vehType": "util",
      "sostituzione": "104.6966667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1108",
      "description": "Cerchio in lega POST SX",
      "vehType": "util",
      "sostituzione": "334.24",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1112",
      "description": "Sostegno/supporto (ruota scorta)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1114",
      "description": "Cerchione POST SX (ferro)",
      "vehType": "util",
      "sostituzione": "81.54",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#00254e": "1"
  },
  {
      "code": "1201",
      "description": "Tappo carburante lato DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1202",
      "description": "Sportello carburante lato DX",
      "vehType": "util",
      "sostituzione": "28.15",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "1203",
      "description": "Errato rifornimento",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1204",
      "description": "Modanatura parafango POST",
      "vehType": "util",
      "sostituzione": "74.57",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1206",
      "description": "Pneumatico POST DX",
      "vehType": "util",
      "sostituzione": "110.5",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1207",
      "description": "Cerchio in acciaio POST DX",
      "vehType": "util",
      "sostituzione": "104.6966667",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1208",
      "description": "Cerchio in lega POST",
      "vehType": "util",
      "sostituzione": "334.24",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1222",
      "description": "Cerchione POST DX (ferro)",
      "vehType": "util",
      "sostituzione": "83.08",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#004e4e": "1"
  },
  {
      "code": "1223",
      "description": "Arco passaruota POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1225",
      "description": "Sostegno/supporto",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1301",
      "description": "Griglia paraurti POST",
      "vehType": "util",
      "sostituzione": "431.5",
      "lieve": "24.4",
      "medio": "65",
      "grave": "100.4",
      "#eaf910": "1"
  },
  {
      "code": "1302",
      "description": "Spoiler paraurti POST",
      "vehType": "util",
      "sostituzione": "293.89",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1303",
      "description": "Luce POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1304",
      "description": "Targa POST",
      "vehType": "util",
      "sostituzione": "340",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1305",
      "description": "Griglia paraurti ANT inf.",
      "vehType": "util",
      "sostituzione": "383.49",
      "lieve": "20.8",
      "medio": "56.6",
      "grave": "84.8",
      "#3828db": "1"
  },
  {
      "code": "1306",
      "description": "Stemma POST",
      "vehType": "util",
      "sostituzione": "45.83",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1307",
      "description": "Freccia POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1308",
      "description": "Luce retronebbia posteriore",
      "vehType": "util",
      "sostituzione": "36.87",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1309",
      "description": "Gancio di traino smontabile J",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1310",
      "description": "Luce POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1311",
      "description": "Fanale POST SX",
      "vehType": "util",
      "sostituzione": "547.845",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1312",
      "description": "Fanale POST DX",
      "vehType": "util",
      "sostituzione": "547.845",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1313",
      "description": "Freccia POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1314",
      "description": "Luce targa singola",
      "vehType": "util",
      "sostituzione": "22.69",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1317",
      "description": "Gancio di traino",
      "vehType": "util",
      "sostituzione": "119.615",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1322",
      "description": "Serratura portello posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#eaf910": "1"
  },
  {
      "code": "1325",
      "description": "Luce di posizione POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "1326",
      "description": "Luce di posizione POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "1401",
      "description": "Spazzole tergicristallo ANT",
      "vehType": "util",
      "sostituzione": "49.56",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1402",
      "description": "Braccio tergicristallo ANT",
      "vehType": "util",
      "sostituzione": "39.23",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1403",
      "description": "Braccio tergicristallo ANT DX",
      "vehType": "util",
      "sostituzione": "56.91",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1404",
      "description": "Braccio tergicristallo ANT SX",
      "vehType": "util",
      "sostituzione": "56.91",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1405",
      "description": "Spazzola tergicristallo ANT DX",
      "vehType": "util",
      "sostituzione": "24.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1406",
      "description": "Spazzola tergicristallo ANT SX",
      "vehType": "util",
      "sostituzione": "24.65",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1407",
      "description": "Spazzole tergicristallo",
      "vehType": "util",
      "sostituzione": "51.05",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1505",
      "description": "Tappo gancio traino paraurti (ANT e POST)",
      "vehType": "util",
      "sostituzione": "50.13",
      "lieve": "",
      "medio": "49",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1",
      "#af28db": "1",
      "#eaf910": "1",
      "#87a5f0": "1"
  },
  {
      "code": "1508",
      "description": "Fisso parafango ant. SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1509",
      "description": "Fisso parafango ant. DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1510",
      "description": "Luce di posizione ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "1511",
      "description": "Luce di posizione ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "1512",
      "description": "Monobraccio tergicristallo anteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3828db": "1"
  },
  {
      "code": "1700",
      "description": "Chiave (seconda chiave)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1702",
      "description": "Manuale d'uso e manutenzione",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1703",
      "description": "Radio (vedi allestimento)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1704",
      "description": "Accendisigari",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1705",
      "description": "Posacenere",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1706",
      "description": "Leva cambio (pomello)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1708",
      "description": "Retrovisore interno",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1709",
      "description": "Comando regolazione retrovisore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1710",
      "description": "Cruscotto (plancia)",
      "vehType": "util",
      "sostituzione": "1237.83",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1713",
      "description": "Poggiatesta sedile singolo",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1720",
      "description": "Cappelliera post.",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1721",
      "description": "Triangolo di emergenza",
      "vehType": "util",
      "sostituzione": "14.35",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1722",
      "description": "Chiave smontaruota",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1723",
      "description": "Crick ruota scorta (martinetto)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1725",
      "description": "Altoparlanti tweeter",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1726",
      "description": "Altoparlante posteriore/sub",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1727",
      "description": "Compressore d'aria",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1728",
      "description": "Maniglia porta ANT interna (SX o DX)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1729",
      "description": "Manovella alzacristalli",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1730",
      "description": "Estintore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1731",
      "description": "Rivestimento vano bagagli LAT",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1732",
      "description": "Ripiano interno copribagagliaio",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1733",
      "description": "Telecomando",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1734",
      "description": "Caricatore CD",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1735",
      "description": "Portabollo/assicurazione",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1736",
      "description": "Moquette",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1737",
      "description": "Tappetini",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1738",
      "description": "Cinture di Sicurezza ",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1739",
      "description": "Rivestimento interno tetto (cielo)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1740",
      "description": "Kit prontosoccorso",
      "vehType": "util",
      "sostituzione": "23.74",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1741",
      "description": "Bullone antifurto",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1742",
      "description": "Plafoniera interna",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1743",
      "description": "Rete fermabagagli",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1745",
      "description": "Cassetto portaoggetti (sportello)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1747",
      "description": "Riparo inferiore CARTER MOTORE",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1748",
      "description": "Airbag passeggero",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1749",
      "description": "Airbag lato guida",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1750",
      "description": "Pulizia interni extra",
      "vehType": "util",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1751",
      "description": "Poggiabraccia ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1752",
      "description": "Poggiabraccia POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1754",
      "description": "Tunnel centrale completo",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1755",
      "description": "Moquette ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1756",
      "description": "Moquette ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1757",
      "description": "Moquette POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1758",
      "description": "Moquette POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1759",
      "description": "Quadro strumenti",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1760",
      "description": "Pannello porta ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1761",
      "description": "Poggiatesta ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1763",
      "description": "Schienale sedile ANT SX (solo fodera)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1764",
      "description": "Seduta ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1765",
      "description": "Comando alzavetro ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1766",
      "description": "Comandoalzavetro ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1767",
      "description": "Comandoalzavetro POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1768",
      "description": "Comando alzavetro POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1770",
      "description": "Pannello porta ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1771",
      "description": "Poggiatesta ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1772",
      "description": "Schienale sedile ANT DX (solo fodera)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1773",
      "description": "Seduta ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1774",
      "description": "Sedile passeggero COMPLETO",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1776",
      "description": "Poggiatesta POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1777",
      "description": "Schienale sedile POST DX (solo fodera)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1778",
      "description": "Seduta sedile POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1779",
      "description": "Schienale sedile POST SX (solo fodera)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1780",
      "description": "Pannello interno portello posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1781",
      "description": "Seduta sedile POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1783",
      "description": "Cintura di sicurezza POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1784",
      "description": "Altoparlante ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1785",
      "description": "Altoparlante POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1786",
      "description": "Altoparlante ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1787",
      "description": "Altoparlante POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1788",
      "description": "Aletta parasole ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1790",
      "description": "Pannello porta POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1791",
      "description": "Impianto di navigazione (solo display)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1792",
      "description": "Poggiabraccia POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1793",
      "description": "Poggiabraccia ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1794",
      "description": "Airbag laterale SX tendina",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1795",
      "description": "Airbag laterale DX tendinta",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1796",
      "description": "Poggiatesta POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1797",
      "description": "Cintura di sicurezza POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1804",
      "description": "Coprimozzo ",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1811",
      "description": "Disco GPS",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1812",
      "description": "Kit attrezzi",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1813",
      "description": "Giubbino di emergenza",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4001",
      "description": "Cerchione ANT DX in ferro",
      "vehType": "util",
      "sostituzione": "83.08",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#051616": "1"
  },
  {
      "code": "6061",
      "description": "Freccia retrovisore SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1"
  },
  {
      "code": "6071",
      "description": "Freccia retrovisore DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#26f719": "1"
  },
  {
      "code": "7301",
      "description": "Ruota di scorta in ferro ruotino",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "7302",
      "description": "Ruota di scorta in lega",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11D",
      "description": "Modanatura montante porta post. SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "11WA",
      "description": "Passaruota/Parasassi Int. ANT, parte ANT/POST",
      "vehType": "util",
      "sostituzione": "72.34",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#ee1313": "1",
      "#26f719": "1"
  },
  {
      "code": "12D",
      "description": "Modanatura montante porta post. DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "13L1",
      "description": "Luce antinebbia POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#af28db": "1"
  },
  {
      "code": "13R1",
      "description": "Luce antinebbia POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#87a5f0": "1"
  },
  {
      "code": "17B1",
      "description": "Sedile POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B2",
      "description": "Seduta POST centrale",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17B3",
      "description": "Sedile POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F1",
      "description": "Sedile ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F2",
      "description": "Sedile ANT centrale",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17F3",
      "description": "Sedile ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T7",
      "description": "Comandi climatizzatore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U5",
      "description": "Portachiavi",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U6",
      "description": "Specchio di cortesia",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U7",
      "description": "Cintura di sicurezza ANT DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U9",
      "description": "Cintura di sicurezza ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W1",
      "description": "Rivestimento interno (battivaligia)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W2",
      "description": "Aletta parasole ANT SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W4",
      "description": "SD GPS",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W5",
      "description": "Caricabatteria GPS",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W6",
      "description": "Staffa supporto GPS",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W7",
      "description": "Contenitore GPS",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W8",
      "description": "Custodia GPS",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17X1",
      "description": "Cavo di ricarica veicolo elettrico",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "6B",
      "description": "Modanatura montante porta ant. SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "7B",
      "description": "Modanatura montante porta ant. DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "8C",
      "description": "Modanatura montante centrale SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#db6928": "1"
  },
  {
      "code": "9C",
      "description": "Modanatura montante centrale DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": "",
      "#3e6928": "1"
  },
  {
      "code": "3A",
      "description": "Parete laterale esterna SX (truck)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "4A",
      "description": "Parete laterale esterna DX (truck)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "81",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "82",
      "description": "Pannello superiore portello posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "83",
      "description": "Pannello inferiore portello posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "122",
      "description": "Pannello superiore porta carico POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "123",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "132",
      "description": "Pannello MONTANTE superiore POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "133",
      "description": "Pannello inferiore POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "134",
      "description": "Pannello MONTANTE superiore POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "135",
      "description": "Pannello inferiore POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "220",
      "description": "Luce di ingombro dx",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "302",
      "description": "Modanatura laterale SX (rifinitura lat.plastica)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "507",
      "description": "Parete divisoria vano di carico",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "709",
      "description": "Specchio retrovisore supplementare",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "711",
      "description": "Pedana di carico DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "803",
      "description": "Cilindretto serratura portello post",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "808",
      "description": "Fascia paracolpi  porta carico  POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "815",
      "description": "Protezione inferiore laterale SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "817",
      "description": "Barra di protezione lato guida",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "903",
      "description": "Serratura porta POST",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "915",
      "description": "Protezione inferiore laterale DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "917",
      "description": "Barra di protezione lato passeggero",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1004",
      "description": "Pedana posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1105",
      "description": "Vetro laterale POST SX truck",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1110",
      "description": "Pannello laterale interno SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1111",
      "description": "Pannello inferiore porta carico POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1113",
      "description": "Pannello interno posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1205",
      "description": "Vetro laterale DX truck",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1209",
      "description": "Vetro laterale POST DX truck",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1210",
      "description": "Pannello laterale interno DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1220",
      "description": "Pannello superiore porta carico POST SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1221",
      "description": "Pannello inferiore porta carico POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1315",
      "description": "Fascia paracolpi porta carico POST DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1316",
      "description": "Soglia acceso vano carico(Truck)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1501",
      "description": "Pannello interno DX superiore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1502",
      "description": "Pannello interno DX inferiore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1503",
      "description": "Pannello interno SX superiore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1504",
      "description": "Pannello interno SX inferiore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1520",
      "description": "Luce di ingombro sx",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1746",
      "description": "Piano di carico posteiore interno",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1753",
      "description": "Divisorio vano carico",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1799",
      "description": "Unità di controllo interna",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1809",
      "description": "Adesivo Europcar",
      "vehType": "util",
      "sostituzione": "100",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "1810",
      "description": "Deflettore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "11CO",
      "description": "Angolare truck",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "12CO",
      "description": "Angolare truck",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13L",
      "description": "Angolo SX Paraurti POST solo truck",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "13R",
      "description": "Angolo DX Paraurti POST solo truck",
      "vehType": "util",
      "sostituzione": "7.63",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T1",
      "description": "Terza fila di sedili SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T2",
      "description": "Terza fila di sedili centrale",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17T3",
      "description": "Terza fila di sedili DX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U1",
      "description": "Rivestimento verticale coibentato",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U2",
      "description": "Pavimento coibentato",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U3",
      "description": "Rivestimento tetto coibentato",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U4",
      "description": "Comando controllo frigo",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17U8",
      "description": "Panca sedile",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "17W3",
      "description": "Pianale di carico (copertura)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "139",
      "description": "Unità di controllo pedana posteriore",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "402",
      "description": "Modanatura laterale DX (rifinitura lat plastica)",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  },
  {
      "code": "611",
      "description": "Pedana di carico SX",
      "vehType": "util",
      "sostituzione": "",
      "lieve": "",
      "medio": "",
      "grave": ""
  }
]

/*
export const ZONE_ELEMENTS = [
  {
    "vehType": "Media Compact",
    "code": "1",
    "description": "Paraurti ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Traversa ant', 'Rivestimento ant', 'Faro SX', 'Faro DX', 'Radiatore']
  },
  {
    "vehType": "Media Compact",
    "code": "2",
    "description": "Cofano",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Montante porta esterno SX','Montante porta esterno DX']
  },
  {
    "vehType": "Media Compact",
    "code": "3",
    "description": "Parafango ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Porta ANT SX']
  },
  {
    "vehType": "Media Compact",
    "code": "4",
    "description": "Parafango ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Porta ANT DX']
  },
  {
    "vehType": "Media Compact",
    "code": "5",
    "description": "Tetto",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "6",
    "description": "Porta ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Parafango ANT SX','Porta POST SX']
  },
  {
    "vehType": "Media Compact",
    "code": "7",
    "description": "Porta ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Parafango ANT DX','Porta POST DX']
  },
  {
    "vehType": "Media Compact",
    "code": "8",
    "description": "Porta POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Porta ANT SX','Parafango POST SX']
  },
  {
    "vehType": "Media Compact",
    "code": "9",
    "description": "Porta POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Porta ANT DX','Parafango POST DX']
  },
  {
    "vehType": "Media Compact",
    "code": "10",
    "description": "Lunotto",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "11",
    "description": "Parafango POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Porta ANT SX','Paraurti POST']
  },
  {
    "vehType": "Media Compact",
    "code": "12",
    "description": "Parafango POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Porta ANT DX','Paraurti POST']
  },
  {
    "vehType": "Media Compact",
    "code": "1010",
    "description": "Portellone POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "13",
    "description": "Paraurti POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null,
    extra: ['Traversa POST','Rivestimento POST','Pavimento']
  },
  {
    "vehType": "Media Compact",
    "code": "14",
    "description": "Parabrezza",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "16",
    "description": "Porta POST laterale DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "31",
    "description": "Cerchione ANT SX in ferro",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "36",
    "description": "Pannelli porte (SX o DX)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1320",
    "description": "Paraurti centrale posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1L",
    "description": "Paraurti ANT (lato sx)",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1L01",
    "description": "Minigonna ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1R",
    "description": "Paraurti ANT (lato dx)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1R01",
    "description": "Minigonna ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "3WA",
    "description": "Arco passaruota ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "4WA",
    "description": "Arco passaruota ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "78",
    "description": "Coppa ruota",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": "1",
    "#00254e": "1",
    "#004e4e": "1"
  },
  {
    "vehType": "Media Compact",
    "code": "80",
    "description": "Coprimozzo ",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": "1",
    "#00254e": "1",
    "#004e4e": "1"
  },
  {
    "vehType": "Media Compact",
    "code": "84",
    "description": "Portatarga",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "100",
    "description": "Proiettore ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "101",
    "description": "Griglia paraurti ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "102",
    "description": "Spoiler paraurti ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "103",
    "description": "Proiettore ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "104",
    "description": "Targa ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "105",
    "description": "Griglia ANT (nel cofano o separata)",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "106",
    "description": "Stemma ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "107",
    "description": "Freccia ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "108",
    "description": "Faro antinebbia SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "109",
    "description": "Modanatura paraurti ANT (DX o SX)",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "110",
    "description": "Freccia ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "111",
    "description": "Faro antinebbia DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "118",
    "description": "Coppa ruota",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "126",
    "description": "Interruttore accensione luci",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "130",
    "description": "Luce diurna ANT DX Posizione",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "138",
    "description": "Spazzola tergicristallo posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "140",
    "description": "Luce diurna ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "141",
    "description": "Volante",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "301",
    "description": "Indicatore di direzione SX (laterale parafango)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "306",
    "description": "Pneumatico ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "307",
    "description": "Cerchio in acciaio ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "308",
    "description": "Cerchio in lega ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "401",
    "description": "Indicatore di direzione DX (laterale parafango)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "406",
    "description": "Pneumatico ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": "1",
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "407",
    "description": "Cerchio in acciaio ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": "1",
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "408",
    "description": "Cerchio in lega ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": "1",
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "501",
    "description": "Antenna",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "502",
    "description": "Barre mancorrenti",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "503",
    "description": "Capote COMPLETA",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "504",
    "description": "Tetto apribile (lamierato)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "505",
    "description": "Copertura capote solo tela",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "506",
    "description": "Spoiler portello",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "510",
    "description": "Rivestimento anteriore esterno",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "511",
    "description": "Tetto retraibile (tettuccio senza meccanismo)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "560",
    "description": "Barra tetto SX Modan",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "570",
    "description": "Barra tetto DX Modan",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": "1",
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "601",
    "description": "Sottoporta SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "602",
    "description": "Modanatura porta ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "603",
    "description": "Serie cilindretti serrature",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "604",
    "description": "Maniglia porta esterna ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "605",
    "description": "Vetro scendente ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "606",
    "description": "Calotta retrovisore SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "607",
    "description": "Retrovisore lato guida",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "609",
    "description": "Vetro fisso ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "612",
    "description": "Cristallo retrovisore SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "701",
    "description": "Sottoporta DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "702",
    "description": "Modanatura porta ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "703",
    "description": "Cilindretto serratura porta ant.",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "704",
    "description": "Maniglia porta esterna ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "705",
    "description": "Vetro scendente ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "706",
    "description": "Calotta retrovisore DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "707",
    "description": "Retrovisore lato passggero",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "712",
    "description": "Cristallo retrovisore DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "713",
    "description": "Vetro fisso ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "804",
    "description": "Maniglia porta esterna POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "805",
    "description": "Vetro scendente porta POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "806",
    "description": "Vetro fisso POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "807",
    "description": "Guarnizione porta POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "811",
    "description": "Pannello porta POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "904",
    "description": "Maniglia porta esterna POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "905",
    "description": "Vetro scendenteporta POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "906",
    "description": "Vetro fisso POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "907",
    "description": "Guarnizione porta POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "908",
    "description": "Modanatura paraurti POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1001",
    "description": "Spazzole tergicristallo POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1002",
    "description": "Braccio tergicristallo POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1003",
    "description": "Luce terzo stop",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1011",
    "description": "Maniglia apertura portello post",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1013",
    "description": "Meccanismo apertura\/chiusura capote",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1014",
    "description": "Terminale di scarico (silenz di scarico)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": "1",
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1101",
    "description": "Tappo carburante lato SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1102",
    "description": "Sportello carburante lato SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1103",
    "description": "Modanatura parafango ANT ",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1106",
    "description": "Pneumatico POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": "1",
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1107",
    "description": "Cerchio in acciaio POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": "1",
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1108",
    "description": "Cerchio in lega POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": "1",
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1112",
    "description": "Sostegno\/supporto (ruota scorta)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1114",
    "description": "Cerchione POST SX (ferro)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": "1",
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1201",
    "description": "Tappo carburante lato DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1202",
    "description": "Sportello carburante lato DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1203",
    "description": "Errato rifornimento",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1204",
    "description": "Modanatura parafango POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1206",
    "description": "Pneumatico POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": "1"
  },
  {
    "vehType": "Media Compact",
    "code": "1207",
    "description": "Cerchio in acciaio POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": "1"
  },
  {
    "vehType": "Media Compact",
    "code": "1208",
    "description": "Cerchio in lega POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": "1"
  },
  {
    "vehType": "Media Compact",
    "code": "1222",
    "description": "Cerchione POST DX (ferro)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": "1"
  },
  {
    "vehType": "Media Compact",
    "code": "1223",
    "description": "Arco passaruota POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1225",
    "description": "Sostegno\/supporto",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1301",
    "description": "Griglia paraurti POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1302",
    "description": "Spoiler paraurti POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1303",
    "description": "Luce POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1304",
    "description": "Targa POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1305",
    "description": "Griglia paraurti ANT inf.",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1306",
    "description": "Stemma POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1307",
    "description": "Freccia POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1308",
    "description": "Luce retronebbia posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1309",
    "description": "Gancio di traino smontabile J",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1310",
    "description": "Luce POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1311",
    "description": "Fanale POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1312",
    "description": "Fanale POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1313",
    "description": "Freccia POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1314",
    "description": "Luce targa singola",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1317",
    "description": "Gancio di traino",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1322",
    "description": "Serratura portello posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": "1",
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1325",
    "description": "Luce di posizione POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1326",
    "description": "Luce di posizione POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1401",
    "description": "Spazzole tergicristallo ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1402",
    "description": "Braccio tergicristallo ANT",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1403",
    "description": "Braccio tergicristallo ANT DX",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1404",
    "description": "Braccio tergicristallo ANT SX",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1405",
    "description": "Spazzola tergicristallo ANT DX",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1406",
    "description": "Spazzola tergicristallo ANT SX",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1407",
    "description": "Spazzole tergicristallo",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1505",
    "description": "Tappo gancio traino paraurti (ANT e POST)",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": "1",
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1508",
    "description": "Fisso parafango ant. SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1509",
    "description": "Fisso parafango ant. DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1510",
    "description": "Luce di posizione ANT SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1511",
    "description": "Luce di posizione ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1512",
    "description": "Monobraccio tergicristallo anteriore",
    "#ee1313": null,
    "#3828db": "1",
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1700",
    "description": "Chiave (seconda chiave)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1702",
    "description": "Manuale d'uso e manutenzione",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1703",
    "description": "Radio (vedi allestimento)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1704",
    "description": "Accendisigari",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1705",
    "description": "Posacenere",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1706",
    "description": "Leva cambio (pomello)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1708",
    "description": "Retrovisore interno",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1709",
    "description": "Comando regolazione retrovisore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1710",
    "description": "Cruscotto (plancia)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1713",
    "description": "Poggiatesta sedile singolo",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1720",
    "description": "Cappelliera post.",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1721",
    "description": "Triangolo di emergenza",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1722",
    "description": "Chiave smontaruota",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1723",
    "description": "Crick ruota scorta (martinetto)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1725",
    "description": "Altoparlanti tweeter",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1726",
    "description": "Altoparlante posteriore\/sub",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1727",
    "description": "Compressore d'aria",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1728",
    "description": "Maniglia porta ANT interna (SX o DX)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1729",
    "description": "Manovella alzacristalli",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1730",
    "description": "Estintore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1731",
    "description": "Rivestimento vano bagagli LAT",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1732",
    "description": "Ripiano interno copribagagliaio",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1733",
    "description": "Telecomando",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1734",
    "description": "Caricatore CD",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1735",
    "description": "Portabollo\/assicurazione",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1736",
    "description": "Moquette",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1737",
    "description": "Tappetini",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1738",
    "description": "Cinture di Sicurezza ",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1739",
    "description": "Rivestimento interno tetto (cielo)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1740",
    "description": "Kit prontosoccorso",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1741",
    "description": "Bullone antifurto",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1742",
    "description": "Plafoniera interna",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1743",
    "description": "Rete fermabagagli",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1745",
    "description": "Cassetto portaoggetti (sportello)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1747",
    "description": "Riparo inferiore CARTER MOTORE",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1748",
    "description": "Airbag passeggero",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1749",
    "description": "Airbag lato guida",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1750",
    "description": "Pulizia interni extra",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1751",
    "description": "Poggiabraccia ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1752",
    "description": "Poggiabraccia POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1754",
    "description": "Tunnel centrale completo",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1755",
    "description": "Moquette ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1756",
    "description": "Moquette ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1757",
    "description": "Moquette POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1758",
    "description": "Moquette POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1759",
    "description": "Quadro strumenti",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1760",
    "description": "Pannello porta ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1761",
    "description": "Poggiatesta ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1763",
    "description": "Schienale sedile ANT SX (solo fodera)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1764",
    "description": "Seduta ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1765",
    "description": "Comando alzavetro ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1766",
    "description": "Comandoalzavetro ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1767",
    "description": "Comandoalzavetro POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1768",
    "description": "Comando alzavetro POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1770",
    "description": "Pannello porta ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1771",
    "description": "Poggiatesta ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1772",
    "description": "Schienale sedile ANT DX (solo fodera)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1773",
    "description": "Seduta ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1774",
    "description": "Sedile passeggero COMPLETO",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1776",
    "description": "Poggiatesta POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1777",
    "description": "Schienale sedile POST DX (solo fodera)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1778",
    "description": "Seduta sedile POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1779",
    "description": "Schienale sedile POST SX (solo fodera)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1780",
    "description": "Pannello interno portello posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1781",
    "description": "Seduta sedile POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1783",
    "description": "Cintura di sicurezza POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1784",
    "description": "Altoparlante ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1785",
    "description": "Altoparlante POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1786",
    "description": "Altoparlante ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1787",
    "description": "Altoparlante POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1788",
    "description": "Aletta parasole ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1790",
    "description": "Pannello porta POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1791",
    "description": "Impianto di navigazione (solo display)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1792",
    "description": "Poggiabraccia POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1793",
    "description": "Poggiabraccia ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1794",
    "description": "Airbag laterale SX tendina",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1795",
    "description": "Airbag laterale DX tendinta",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1796",
    "description": "Poggiatesta POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1797",
    "description": "Cintura di sicurezza POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1804",
    "description": "Coprimozzo ",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1811",
    "description": "Disco GPS",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1812",
    "description": "Kit attrezzi",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1813",
    "description": "Giubbino di emergenza",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "4001",
    "description": "Cerchione ANT DX in ferro",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": "1",
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "6061",
    "description": "Freccia retrovisore SX",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "6071",
    "description": "Freccia retrovisore DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "7301",
    "description": "Ruota di scorta in ferro ruotino",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "7302",
    "description": "Ruota di scorta in lega",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "11D",
    "description": "Modanatura montante porta post. SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "11WA",
    "description": "Passaruota\/Parasassi Int. ANT, parte ANT\/POST",
    "#ee1313": "1",
    "#3828db": null,
    "#26f719": "1",
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "12D",
    "description": "Modanatura montante porta post. DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "13L1",
    "description": "Luce antinebbia POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": "1",
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "13R1",
    "description": "Luce antinebbia POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": "1",
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17B1",
    "description": "Sedile POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17B2",
    "description": "Seduta POST centrale",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17B3",
    "description": "Sedile POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17F1",
    "description": "Sedile ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17F2",
    "description": "Sedile ANT centrale",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17F3",
    "description": "Sedile ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17T7",
    "description": "Comandi climatizzatore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U5",
    "description": "Portachiavi",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U6",
    "description": "Specchio di cortesia",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U7",
    "description": "Cintura di sicurezza ANT DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U9",
    "description": "Cintura di sicurezza ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W1",
    "description": "Rivestimento interno (battivaligia)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W2",
    "description": "Aletta parasole ANT SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W4",
    "description": "SD GPS",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W5",
    "description": "Caricabatteria GPS",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W6",
    "description": "Staffa supporto GPS",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W7",
    "description": "Contenitore GPS",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W8",
    "description": "Custodia GPS",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17X1",
    "description": "Cavo di ricarica veicolo elettrico",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "6B",
    "description": "Modanatura montante porta ant. SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "7B",
    "description": "Modanatura montante porta ant. DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "8C",
    "description": "Modanatura montante centrale SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": "1",
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "9C",
    "description": "Modanatura montante centrale DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": "1",
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "3A",
    "description": "Parete laterale esterna SX (truck)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "4A",
    "description": "Parete laterale esterna DX (truck)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "81",
    "description": "Pannello inferiore porta carico POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "82",
    "description": "Pannello superiore portello posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "83",
    "description": "Pannello inferiore portello posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "122",
    "description": "Pannello superiore porta carico POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "123",
    "description": "Pannello inferiore porta carico POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "132",
    "description": "Pannello MONTANTE superiore POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "133",
    "description": "Pannello inferiore POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "134",
    "description": "Pannello MONTANTE superiore POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "135",
    "description": "Pannello inferiore POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "220",
    "description": "Luce di ingombro dx",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "302",
    "description": "Modanatura laterale SX (rifinitura lat.plastica)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "507",
    "description": "Parete divisoria vano di carico",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "709",
    "description": "Specchio retrovisore supplementare",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "711",
    "description": "Pedana di carico DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "803",
    "description": "Cilindretto serratura portello post",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "808",
    "description": "Fascia paracolpi  porta carico  POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "815",
    "description": "Protezione inferiore laterale SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "817",
    "description": "Barra di protezione lato guida",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "903",
    "description": "Serratura porta POST",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "915",
    "description": "Protezione inferiore laterale DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "917",
    "description": "Barra di protezione lato passeggero",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1004",
    "description": "Pedana posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1105",
    "description": "Vetro laterale POST SX truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1110",
    "description": "Pannello laterale interno SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1111",
    "description": "Pannello inferiore porta carico POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1113",
    "description": "Pannello interno posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1205",
    "description": "Vetro laterale DX truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1209",
    "description": "Vetro laterale POST DX truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1210",
    "description": "Pannello laterale interno DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1220",
    "description": "Pannello superiore porta carico POST SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1221",
    "description": "Pannello inferiore porta carico POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1315",
    "description": "Fascia paracolpi porta carico POST DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1316",
    "description": "Soglia acceso vano carico(Truck)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1501",
    "description": "Pannello interno DX superiore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1502",
    "description": "Pannello interno DX inferiore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1503",
    "description": "Pannello interno SX superiore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1504",
    "description": "Pannello interno SX inferiore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1520",
    "description": "Luce di ingombro sx",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1746",
    "description": "Piano di carico posteiore interno",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1753",
    "description": "Divisorio vano carico",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1799",
    "description": "Unità di controllo interna",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1809",
    "description": "Adesivo Europcar",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "1810",
    "description": "Deflettore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "11CO",
    "description": "Angolare truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "12CO",
    "description": "Angolare truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "13L",
    "description": "Angolo SX Paraurti POST solo truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "13R",
    "description": "Angolo DX Paraurti POST solo truck",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17T1",
    "description": "Terza fila di sedili SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17T2",
    "description": "Terza fila di sedili centrale",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17T3",
    "description": "Terza fila di sedili DX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U1",
    "description": "Rivestimento verticale coibentato",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U2",
    "description": "Pavimento coibentato",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U3",
    "description": "Rivestimento tetto coibentato",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U4",
    "description": "Comando controllo frigo",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17U8",
    "description": "Panca sedile",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "17W3",
    "description": "Pianale di carico (copertura)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "139",
    "description": "Unità di controllo pedana posteriore",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "402",
    "description": "Modanatura laterale DX (rifinitura lat plastica)",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
  {
    "vehType": "Media Compact",
    "code": "611",
    "description": "Pedana di carico SX",
    "#ee1313": null,
    "#3828db": null,
    "#26f719": null,
    "#db6928": null,
    "#3e6928": null,
    "#b1a558": null,
    "#af28db": null,
    "#eaf910": null,
    "#87a5f0": null,
    "#051616": null,
    "#002529": null,
    "#00254e": null,
    "#004e4e": null
  },
]
*/

export const getFilteredElements = (color: string, vehType:string): any[] => {
  return ZONE_ELEMENTS.filter(v => { return v.vehType==vehType && (+v.lieve + +v.medio + +v.grave + +v.sostituzione > 0) && v[color] })
}



export const MD5 = function (d) {
  let result = M(V(Y(X(d), 8 * d.length)));
  return result.toLowerCase()
};

function M(d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f }
function X(d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0; for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ }
function V(d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ }
function Y(d, _) { d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) { var h = m, t = f, g = r, e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e) } return Array(m, f, r, i) } function md5_cmn(d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) } function md5_ff(d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) } function md5_gg(d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) } function md5_hh(d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) } function md5_ii(d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) } function safe_add(d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m } function bit_rol(d, _) { return d << _ | d >>> 32 - _ }
